import React, { Component } from 'react';
import axios from 'axios';
import { Prompt } from "react-router-dom";
import PropTypes from 'prop-types';
import base64Img from 'base64-img';
import LocalizedStrings from 'react-localization';
import { SetComponentLanguage, GetNearestTableAncestorId, ApiRequest, ReturnTimeZone, getUrlParams } from '../../helpers';
import { arrayMove } from 'react-sortable-hoc';
import en from './locales/en.json';
import fr from './locales/fr.json';
import moment from 'moment-timezone';
import Venue from './Venue/Venue';
import Price from './Price/Price';
import PriceVOD from './PriceVOD/PriceVOD';
import PriceStream from './PriceStream/PriceStream';
import PriceBroadcast from './PriceBroadcast/PriceBroadcast';
import ConfirmDeletePrice from './ConfirmDeletePrice/ConfirmDeletePrice';
import Share from '../Common/Share/Share';
import Details from './Details/Details';
import Graphics from './Graphics/Graphics';
import Dates from './Dates/Dates';
import DatesModal from './DatesModal/DatesModal';
import PriceAlertModal from './PriceAlertModal/PriceAlertModal';
import GlobalPriceModal from './GlobalPriceModal/GlobalPriceModal';
import ConfirmDeleteEventModal from './ConfirmDeleteEventModal/ConfirmDeleteEventModal';
import ConfirmGlobalChange from './ConfirmGlobalChange/ConfirmGlobalChange';
import Message from '../Common/Message/Message';
import MTIModal from './MTIModal/MTIModal';
import MTIModalError from './MTIModalError/MTIModalError';
import DPSModal from './DPSModal/DPSModal';
import NoDatesModalError from './NoDatesModalError/NoDatesModalError';
import './CreateEvent.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);
let previousPrices = 0;
class CreateEvent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            event_id: undefined,
            client: {
                id: null,
                daily_email: false,
                client_name: '',
                client_email: '',
                client_phone: '',
                billing_contact: '',
                billing_address_1: '',
                billing_address_2: '',
                billing_city: '',
                billing_country: 'US',
                billing_state: 'AL',
                billing_zip: '',
                referred_by: '',
                donation: false,
                donation_text: '',
                donation_email: '',
                collect_cust_info: false,
                allow_will_call: false,
                allow_callcenter_refund: false,
                allow_callcenter_exchange: false,
                url_short_name: '',
                payout_option: 'check-at-close',
                payout_frequency: 'daily',
            },
            event: {
                isPublished: false,
                isConfirmDeletePriceOpen: false,
                venue: {
                    venue_type: 'reserved',
                    id: undefined,
                    name: undefined,
                    address: undefined,
                    city: undefined,
                    country: 'US',
                    state: 'AL',
                    zip: undefined,
                    phone: undefined,
                    fax: undefined,
                    timezone: '',
                    max_seats: 0,
                    chart: 0,
                    sections: [],
                    status: 'pending',
                },
                prices: [
                    {
                        id: Date.now(),
                        desc: '',
                        amount: 0.00,
                        delete: false,
                        isNew: true,
                        validation: {
                            valid: true
                        }
                    }
                ],
                fees: [
                    {
                        id: Date.now(),
                        desc: '',
                        amount: 0.00,
                        delete: false,
                        isNew: true,
                        validation: {
                            valid: true
                        }
                    }
                ],
                artists: [
                    {
                        id: Date.now(),
                        first_name: '', 
                        last_name: '', 
                        position: '',
                        isNew: true,
                        delete: false
                    }
                ],
                details: {
                    license_access_code: '',
                    licensing_house: 'Other/Multiple/Royalty Free',
                    searchTerm: '',
                    existingMitShows: [],
                    event_id: undefined,
                    event_type: 'Event',
                    contact_email: undefined,
                    name: undefined,
                    contact_phone: undefined,
                    short_name: '',
                    tickets_per_user: 1000,
                    desc: '',
                    mti_show: false,
                    event_website: undefined,
                    service_fee: 'customer',
                    playbilder_url: undefined,
                    img:undefined,
                    poster_graphic_url:undefined,
                    ad_graphic_url:undefined,
                    ad_graphic_id: null,
                    poster_graphic_id: null,
                    ad_opt_out: false,
                    seat_spacing: 0,
                    status: 'pending',
                },
                dates: {
                    
                }
            },
            wizard: {
                time: '19:00',
                dates: [],
                presale: {
                    start_date: null,
                    start_time: '00:00',
                    end_date: null,
                    end_time: '00:00',
                    password: ''
                },
                public: {
                    start_date: null,
                    start_time: '00:00',
                    end_date: null,
                    end_time: 2
                },
                boxoffice: {
                    end_date: null,
                    end_time: 2
                },
                prices: []
            },
            vod_date: {
                time: '00:00',
                date: null,
                presale: {
                    start_date: null,
                    start_time: '00:00',
                    end_date: null,
                    end_time: '00:00',
                    presale_password: ''
                },
                public: {
                    start_date: null,
                    start_time: '00:00',
                    end_date: null,
                    end_time: '00:00'
                },
                boxoffice: {
                    end_date: null,
                    end_time: '00:00'
                },
                event_subtitle: '',
                prices: [],
                redeem: {
                    start_date: null,
                    start_time: '00:00',
                    end_date: null,
                    end_time: '00:00',
                },
            },
            isReadyVOD: false,
            dates: [],
            prices: [],
            validation: {
                details: {
                    contact_email: {
                        valid: null,
                        msg: ''
                    },
                    name: {
                        valid: null,
                        msg: ''
                    },
                    contact_phone: {
                        valid: null,
                        msg: ''
                    },
                    license_access_code: {
                        valid: null,
                        msg: '',
                    }
                },
                venue: {
                    name: {
                        valid: null,
                        msg: ''
                    },
                    address: {
                        valid: null,
                        msg: ''
                    },
                    phone: {
                        valid: null,
                        msg: ''
                    },
                    fax: {
                        valid: null,
                        msg: ''
                    },
                    city: {
                        valid: null,
                        msg: ''
                    },
                    country: {
                        valid: true,
                        msg: ''
                    },
                    state: {
                        valid: true,
                        msg: ''
                    },
                    zip: {
                        valid: null,
                        msg: ''
                    },
                    max_seats: {
                        valid: null,
                        msg: ''
                    },
                    timezone: {
                        valid: null,
                        msg: ''
                    }
                }
            },
            isEditMode: false,
            isReadyToSubmit: false,
            currentDragTable: '',
            isDatesModalOpen: false,
            isGlobalPriceModalOpen: false,
            eventToDelete: '',
            isConfirmDeleteEventOpen: false,
            isConfirmGlobalChangeOpen: false,
            modalTitle: '',
            modalDescription: '',
            modalButton: '',
            priceToDelete: '',
            isWizardError: false,
            venues: [],
            isShowModalPriceAlert: false,
            message: {
                title: '',
                content: '',
                type: ''
            },
            hasCountPrices: false,
            venueType: '',
            hasNotBeenSavedYet: true,
            selectedMTIshow: {},
            isMTIModalOpen: false,
            isMTIModalErrorOpen: false,
            mti_access_result: {
                accessCode: '',
                aeEmail: '',
                aeName: 'Test',
                bookingId: '',
                date: '',
                contactEmail: '',
                contactName: '',
                contactPhone: '',
                custAddr1: '',
                custAddr2: '',
                custCity: '',
                customerId: '',
                customerName: '',
                custPostal: '',
                custState: '',
                fromDate: '',
                licenseTypes: {
                    streamD: '',
                    streamL: '',
                    streamS: '',
                    physical: ''
                },
                priceMax: '',
                royalties: {
                    streamD: '',
                    streamL: '',
                    streamS: '',
                    physical: ''
                },
                royaltiesMin: {
                    streamD: '',
                    streamL: '',
                    streamS: '',
                    physical: ''
                },
                ticketsMax: '',
                showId: '',
                showName: '',
                toDate: '',
                items: '',
                quantity: '',
                errors: ''
            },
            acceptRoyalties: 'N',
            dps_access_result: {
                access_code: '',
                dps_show_id: '',
                licensing_house: 'Test',
                minimum_royalty: '',
                royalty_percentage: '',
                show_credits: '',
                show_name: '',
                show_synopsis: '',
            },
            isDPSModalOpen: false,
            isNoDatesErrorModalOpen: false,
        }
    }

    setMessage = (title, content, type) => {
        const message = {...this.state.message};
        message['title'] = title;
        message['content'] = content;
        message['type'] = type;
        this.setState({ message });
    }

    toggleModalPriceAlert = () => {
        this.setState({
            isShowModalPriceAlert: !this.state.isShowModalPriceAlert,
        });
    }

    toggleModalMTI = () => {
        this.setState({
            isMTIModalOpen: !this.state.isMTIModalOpen,
        });
    }

    toggleModalMTIError = () => {
        this.setState({
            isMTIModalErrorOpen: !this.state.isMTIModalErrorOpen,
        });
    }

    toggleNoDatesErrorModal = () => {
        this.setState({
            isNoDatesErrorModalOpen: !this.state.isNoDatesErrorModalOpen,
        });
    }

    acceptMTITerms = () => {
        let selectedMTIshow = this.state.selectedMTIshow;
        let event = this.state.event;
        event['details']['mti_show_id'] = parseInt(selectedMTIshow.id);
        event['details']['desc'] = selectedMTIshow.desc;
        event['details']['short_name'] = selectedMTIshow.short_name || selectedMTIshow.name;
        event['details']['name'] = selectedMTIshow.name;
        event['details']['mti_show'] = true;
        //event['venue']['max_seats'] = selectedMTIshow.quantity_stream_tickets || '';
        
        this.setState({
            event,
            isMTIModalOpen: false,
        });
        this.clearValidation('details');
    }

    acceptRoyalties = (value) => {
        let acceptRoyalties = value;
        let mti_access_result = this.state.mti_access_result;
        let event = this.state.event;

        if (value === 'Y') {
            event['details']['mti_show_id'] = parseInt(mti_access_result.bookingId);
            event['details']['name'] = mti_access_result.showName;
            event['details']['short_name'] = mti_access_result.showName;
            event['details']['contact_phone'] = mti_access_result.contactPhone;
            event['details']['contact_email'] = mti_access_result.contactEmail;
            event['venue']['city'] = mti_access_result.custCity;
            event['venue']['zip'] = mti_access_result.custPostal;
            event['venue']['country'] = 'US';
            event['venue']['state'] = mti_access_result.custState;
            //event['venue']['max_seats'] = mti_access_result.ticketsMax !== 'na' ? mti_access_result.ticketsMax : '';
            event['details']['mti_show'] = true;
            //event['venue']['max_seats'] = selectedMTIshow.quantity_stream_tickets || '';
        }
        
        this.setState({
            acceptRoyalties,
            event,
            isMTIModalOpen: false,
        });
        this.clearValidation('details');
    }

    toggleModalDPS = () => {
        this.setState({
            isDPSModalOpen: !this.state.isDPSModalOpen,
        });
    }

    acceptRoyaltiesDPS = (value) => {
        let acceptRoyalties = value;
        let dps_access_result = this.state.dps_access_result;
        let event = this.state.event;

        if (value === 'Y') {
            event['details']['dps_show_id'] = parseInt(dps_access_result.dps_show_id);
            event['details']['name'] = dps_access_result.show_name;
            event['details']['short_name'] = dps_access_result.show_name;
            event['details']['desc'] = dps_access_result.show_synopsis;
        }
        
        this.setState({
            acceptRoyalties,
            event,
            isDPSModalOpen: false,
        });
        this.clearValidation('details');
    }

    sendEmailVOD = (dates) => {
        const event_id = this.state.event_id;
        // Load Event
        const sendEmail = async (date) => {
			try {
                // Get client events
                const emailResponse = await send_email(date);
                console.log('emailResponse', emailResponse);  

                window.open(`/upload/${event_id}`, '_blank');

            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        };

        async function send_email(date) {
            return await ApiRequest(`/video/upload/send-email`, {
                method: 'POST',
                data: {
                    event_date_id: date.id,
                    type: 'vod',
                }
            });
        }

        sendEmail(dates[0]);
    }

    sendEmailPoster = (id) => {
        // Load Event
        const sendEmail = async (id) => {
			try {
                // Get client events
                const emailResponse = await send_email(id);
                console.log('emailResponse', emailResponse);
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        };

        async function send_email(id) {
            return await ApiRequest(`/video/upload/send-email`, {
                method: 'POST',
                data: {
                    event_id: id,
                    type: 'video-poster',
                }
            });
        }

        sendEmail(id);
    }
    
    getActiveEvent = (event_id, checkForPrices) => {
        this.setMessage('', '', 'loading');

        // Load Event
        const getEvent = async () => {
			try {
                // Get client events
                const eventResponse = await get_event();
                console.log('eventResponse', eventResponse);   

                if(eventResponse.data.event){
                    this.setMessage('', '', '');

                    // If is_public, hide Save Draft button
                    this.props.toggleEventDraftButton(eventResponse.data.event.is_public);

                    // If venue is active, activate Save and publish button
                    this.props.toggleSavePublishButton(eventResponse.data.event.venue.status !== 'active');
                    
                    // If VOD and channel is not ready, do not allow to push LIVE
                    //if (eventResponse.data.event.event_type === 'Video On Demand' || eventResponse.data.event.event_type === 'Scheduled Content') {
                    //    this.props.toggleSavePublishButton(eventResponse.data.event.channel_id !== null ? false : true);
                    //}
                    
                    const artists = [];
                    // Check if there are artists
                    if(eventResponse.data.event.artists.length > 0){
                        // Sort in order
                        //eventResponse.data.event.artists.sort(function(a,b){return a.sort() - b.sort()});
                        eventResponse.data.event.artists.forEach((i) => {
                            let artist = {};
                            artist.id = i.id;
                            artist.first_name = i.first_name;
                            artist.last_name = i.last_name;
                            artist.position = i.position;
                            artist.delete = true;
                            artists.push(artist);
                        });
                    }
                    let artistEmpty = {};
                    artistEmpty.id = Date.now();
                    artistEmpty.isNew = true;
                    artistEmpty.first_name = '';
                    artistEmpty.last_name = '';
                    artistEmpty.position = '';
                    artistEmpty.delete = false;
                    artists.push(artistEmpty);

                    const prices = [];
                    // Check if there are prices
                    if(eventResponse.data.event.pricing_options.length > 0){
                        eventResponse.data.event.pricing_options.forEach((i) => {
                            let price = {};
                            price.id = i.id;
                            price.amount = i.amount;
                            price.desc = i.desc;
                            price.isNew = false;
                            price.delete = true;
                            price.validation = {};
                            price.validation.valid = true;
                            price.validation.msg = '';
                            prices.push(price);
                        });
                    }
                    // Create empty
                    let price = {};
                    price.id = Date.now();
                    price.amount = 0;
                    price.isNew = true;
                    price.desc = '';
                    price.delete = false;
                    price.validation = {};
                    price.validation.valid = true;
                    price.validation.msg = '';
                    prices.push(price);

                    if (!this.state.hasCountPrices) {
                        previousPrices = prices.length;
                        this.setState({
                            hasCountPrices: true,
                        });
                    }
                    if(checkForPrices && (previousPrices < prices.length)) {
                        this.setState({
                            isShowModalPriceAlert: true,
                        });
                        previousPrices = prices.length;
                    }

                    const fees = [];
                    // Check if there are prices
                    if(eventResponse.data.event.fees){
                        if(eventResponse.data.event.fees.length > 0){
                            eventResponse.data.event.fees.forEach((i, index) => {
                                let fee = {};
                                fee.id = index;
                                fee.amount = i.amount;
                                fee.desc = i.desc;
                                fee.isNew = false;
                                fee.delete = true;
                                fee.validation = {};
                                fee.validation.valid = true;
                                fee.validation.msg = '';
                                fees.push(fee);
                            });
                        } else {
                            // Create empty
                            let fee = {};
                            fee.id = Date.now();
                            fee.amount = 0;
                            fee.isNew = true;
                            fee.desc = '';
                            fee.delete = false;
                            fee.validation = {};
                            fee.validation.valid = true;
                            fee.validation.msg = '';
                            fees.push(fee);
                        }
                    } else {
                        // Create empty
                        let fee = {};
                        fee.id = Date.now();
                        fee.amount = 0;
                        fee.isNew = true;
                        fee.desc = '';
                        fee.delete = false;
                        fee.validation = {};
                        fee.validation.valid = true;
                        fee.validation.msg = '';
                        fees.push(fee);
                    }

                    // Load Venue Event to get Sections
                    const getVenueEvent = async () => {
                        try {
                            // Get client events
                            const venueEventResponse = await get_venue_event(eventResponse.data.event.venue.id);
                            console.log(venueEventResponse)
                            if(venueEventResponse.data.venue){
                                let sections = [];
                                // If there are sections
                                if(typeof venueEventResponse.data.venue.sections !== 'undefined'){
                                    if(venueEventResponse.data.venue.sections.length > 0){
                                        venueEventResponse.data.venue.sections.forEach((section) => {
                                            let venueSection = {};

                                            console.log(section.id)
                                            venueSection.id = section.id;
                                            venueSection.name = section.name;
                                            sections.push(venueSection);
                                        });
                                    }
                                } else {
                                    let venueSection = {};
                                    if(eventResponse.data.event.event_dates.length > 0){
                                        if (eventResponse.data.event.event_dates[0].section_pricing.length > 0) {
                                            venueSection.id = eventResponse.data.event.event_dates[0].section_pricing[0].id;
                                        } else {
                                            venueSection.id = 0;
                                        }
                                    } else {
                                        venueSection.id = 0;
                                    }
                                    venueSection.name = 'All';
                                    sections.push(venueSection);
                                }

                                let event = {
                                    isPublished: eventResponse.data.event.is_public,
                                    isConfirmDeletePriceOpen: false,
                                    venue: {
                                        venue_type: eventResponse.data.event.venue.venue_type,
                                        id: eventResponse.data.event.venue.id,
                                        name: eventResponse.data.event.venue.name,
                                        address: eventResponse.data.event.venue.address,
                                        city: eventResponse.data.event.venue.city,
                                        country: eventResponse.data.event.venue.country,
                                        state: eventResponse.data.event.venue.state,
                                        zip: eventResponse.data.event.venue.zip,
                                        phone: eventResponse.data.event.venue.phone,
                                        fax: eventResponse.data.event.venue.fax,
                                        timezone: eventResponse.data.event.venue.timezone || '',
                                        max_seats: eventResponse.data.event.venue.max_seats || eventResponse.data.event.quantity_stream_tickets,
                                        chart: eventResponse.data.event.venue.seating_chart_id || 0,
                                        sections: sections,
                                        status: eventResponse.data.event.venue.status
                                    },
                                    prices: prices,
                                    fees: fees,
                                    artists: artists,
                                    details: {
                                        channel_id: eventResponse.data.event.channel_id,
                                        searchTerm: '',
                                        existingMitShows: [],
                                        event_id: eventResponse.data.event.id,
                                        event_type: eventResponse.data.event.event_type,
                                        contact_email: eventResponse.data.event.contact_email,
                                        name: eventResponse.data.event.name,
                                        contact_phone: eventResponse.data.event.contact_phone,
                                        short_name: eventResponse.data.event.short_name,
                                        tickets_per_user: eventResponse.data.event.tickets_per_user,
                                        desc: eventResponse.data.event.desc,
                                        mti_show: eventResponse.data.event.mti_show,
                                        mti_show_id: eventResponse.data.event.mti_show_id,
                                        event_website: eventResponse.data.event.event_website,
                                        service_fee: eventResponse.data.event.service_fee.toLowerCase(),
                                        playbilder_url: eventResponse.data.event.playbilder_url,
                                        img:'',
                                        poster_graphic_url: eventResponse.data.event.poster_graphic_url,
                                        poster_graphic_id: eventResponse.data.event.poster_graphic_id,
                                        ad_graphic_url: eventResponse.data.event.ad_graphic_url,
                                        ad_graphic_id: eventResponse.data.event.ad_graphic_id,
                                        ad_opt_out: eventResponse.data.event.ad_opt_out,
                                        quantity_stream_tickets: eventResponse.data.event.quantity_stream_tickets,
                                        seat_spacing: parseInt(eventResponse.data.event.seat_spacing, 10),
                                        status: eventResponse.data.event.status,
                                    },
                                    dates: {
                                        
                                    }
                                }
                                let venueType = this.state.venueType;
                                if(eventResponse.data.event.venue.id) {
                                    venueType = 'existing';
                                }
            
                                const dates = [];

                                // Get Timezone offset
                                const venueTimezone = event.venue.timezone;
                                if(eventResponse.data.event.event_dates.length > 0){
                                    eventResponse.data.event.event_dates.forEach((i) => {
                                        let event_date = {};
                                        event_date.event_subtitle = i.event_subtitle;
                                        event_date.id = i.id;
                                        
                                        event_date.date = moment.tz(i.event_datetime, venueTimezone).format().toString().substring(0, 10);//moment(i.event_datetime).toString().substring(0,15);
                                        event_date.time = moment.tz(i.event_datetime, venueTimezone).format().toString().substring(11, 16);//moment(i.event_datetime).toString().substring(16, 21);

                                        event_date.presale = {};
                                        if(i.presale_end !== undefined){
                                            event_date.presale.end_date = moment.tz(i.presale_end, venueTimezone).format().toString().substring(0, 10); //moment(i.presale_end).toString().substring(0,15);
                                            if(event_date.presale.end_date === 'Invalid date') {
                                                event_date.presale.end_date = '';
                                            }
                                            event_date.presale.end_time = moment.tz(i.presale_end, venueTimezone).format().toString().substring(11, 16); //moment(i.presale_end).toString().substring(16, 21);
                                        } else {
                                            event_date.presale.end_date = '';
                                            event_date.presale.end_time = '00:00';
                                        }

                                        event_date.presale.presale_password = i.presale_password;
                                        if(i.presale_start !== undefined){
                                            event_date.presale.start_date = moment.tz(i.presale_start, venueTimezone).format().toString().substring(0, 10); //moment(i.presale_start).toString().substring(0,15);
                                            if(event_date.presale.start_date === 'Invalid date') {
                                                event_date.presale.start_date = '';
                                            }
                                            event_date.presale.start_time = moment.tz(i.presale_start, venueTimezone).format().toString().substring(11, 16); //moment(i.presale_start).toString().substring(16,21);
                                        } else {
                                            event_date.presale.start_date = '';
                                            event_date.presale.start_time = '00:00';
                                        }
                                        
                                        event_date.public = {};
                                        event_date.public.end_date = moment.tz(i.sale_end, venueTimezone).toString().substring(0,15);

                                        // If sale is closed, so Public End Sale Date is before Today
                                        const datePublicEnd = moment.tz(i.sale_end, venueTimezone);
                                        //console.log('datePublicEnd', datePublicEnd)
                                        let localUTC = moment.utc();
                                        let dateShow = moment.tz(i.event_datetime, venueTimezone);
                                        //console.log('datePublicEnd.isBefore(localUTC)', datePublicEnd.isBefore(localUTC))
                                        if(datePublicEnd.isBefore(localUTC)){
                                            event_date.public.end_time = '-1000';
                                            event_date.public.end_date = moment.tz(i.sale_end, venueTimezone).toString().substring(0,15);
                                        } else {
                                            const duration = moment.duration(moment(i.event_datetime).diff(moment(i.sale_end)));
                                            event_date.public.end_time = duration.asHours();//Math.abs(duration.asHours()).toFixed(0);
                                            event_date.public.end_date = moment.tz(i.event_datetime, venueTimezone).subtract(Math.abs(duration.asHours()), 'hours').toDate() || '';
                                        }
                                        event_date.public.start_date = moment.tz(i.sale_start, venueTimezone).format().toString().substring(0, 10); //moment(i.sale_start).toString().substring(0,15);
                                        event_date.public.start_time = moment.tz(i.sale_start, venueTimezone).format().toString().substring(11, 16); //moment(i.sale_start).toString().substring(16,21);
                                        
                                        let section_pricings = [];
                                        if(i.section_pricing !== null && i.section_pricing.length > 0){
                                            i.section_pricing.forEach((j) => {
                                                //if(previousSectionPricingID !== j.id){
                                                    j.options.forEach((k) => {
                                                        let section_pricing = {};
                                                        section_pricing.section = j.id;
                                                        section_pricing.price = k.id;
                                                        section_pricing.value = k.value;
                                                        section_pricings.push(section_pricing);
                                                    });
                                                //}
                                            });
                                        } else {
                                            sections.forEach((section) => {
                                                prices.forEach((price) => {
                                                    if(!price.isNew){
                                                        let section_pricing = {};
                                                        section_pricing.section = parseInt(section.id);
                                                        section_pricing.value = "all";
                                                        // if price is new and value is 0, make it box office only
                                                        if (price.isNew && parseInt(price.amount, 10) === 0) {
                                                            section_pricing.value = "box-office";
                                                        }
                                                        section_pricing.price = parseInt(price.id);
                                                        section_pricings.push(section_pricing);
                                                    }
                                                });
                                            });
                                        }

                                        section_pricings = section_pricings.filter((section_pricing, index, self) =>
                                            index === self.findIndex((t) => (
                                                t.section === section_pricing.section && parseInt(t.price) === parseInt(section_pricing.price)
                                            ))
                                        );

                                        event_date.prices = section_pricings;
                                        dates.push(event_date);

                                        // If Video on Demand, use the vod_date to store the date value
                                        if (event.details.event_type === 'Video On Demand') {
                                            event_date.redeem = {};
                                            event_date.id = i.id;
                                            event_date.event_subtitle = i.event_subtitle;
                                            event_date.presale.presale_password = i.presale_password;
                                            event_date.presale.start_time = moment.tz(i.presale_start, venueTimezone).toString().substring(16,21);
                                            event_date.presale.end_time = moment.tz(i.presale_end, venueTimezone).toString().substring(16,21);

                                            // Redeem fields
                                            if (i.redeem_start) {
                                                event_date.redeem.start_date = moment.tz(i.redeem_start, venueTimezone).format().toString().substring(0, 10);
                                                event_date.redeem.start_time = moment.tz(i.redeem_start, venueTimezone).toString().substring(16,21);
                                            } else {
                                                event_date.redeem.start_date = null;
                                                event_date.redeem.start_time = '00:00';
                                            }
                                            if (i.redeem_end) {
                                                event_date.redeem.end_date = moment.tz(i.redeem_end, venueTimezone).format().toString().substring(0, 10); 
                                                event_date.redeem.end_time = moment.tz(i.redeem_end, venueTimezone).toString().substring(16,21);
                                            } else {
                                                event_date.redeem.end_date = null;
                                                event_date.redeem.end_time = '00:00';
                                            }

                                            event_date.public.start_date = moment.tz(i.sale_start, venueTimezone).format().toString().substring(0, 10);
                                            event_date.public.start_time = moment.tz(i.sale_start, venueTimezone).toString().substring(16,21);
                                            event_date.public.end_date = moment.tz(i.sale_end, venueTimezone).format().toString().substring(0, 10); 
                                            event_date.public.end_time = moment.tz(i.sale_end, venueTimezone).toString().substring(16,21);

                                            this.setState({
                                                vod_date: event_date,
                                            });
                                        }
                                    });
                                } else {
                                    // Create empty
                                    /* let event_date = {};
                                    event_date.id = Date.now();
                                    event_date.date = '';
                                    event_date.time = '';
                                    event_date.presale = {};
                                    event_date.presale.end_date = '';
                                    event_date.presale.end_time = '';
                                    event_date.presale.presale_password = '';
                                    event_date.presale.start_date = '';
                                    event_date.presale.start_time = '';
                                    event_date.boxoffice = {};
                                    event_date.boxoffice.end_date = '';
                                    event_date.boxoffice.end_time = 0
                                    event_date.public = {};
                                    event_date.public.end_date = '';
                                    event_date.public.end_time = 0
                                    event_date.public.start_date = '';
                                    event_date.public.start_time = '';
                                    event_date.prices = [];
                                    dates.push(event_date); */
                                }

                                // if first time save draft, send email
                                if (sessionStorage.getItem('first_save_draft') && sessionStorage.getItem('first_save_draft').toString() === 'true') {
                                    if (event.details.event_type === 'Video On Demand' || event.details.event_type === 'Scheduled Content') {
                                        //this.sendEmailVOD(dates);
                                        const event_id = this.state.event_id;
                                        window.open(`/upload/${event_id}`, '_blank');
                                    }
                                    if (event.details.event_type === 'Video On Demand' || event.details.event_type === 'Live Stream' || event.details.event_type === 'Scheduled Content') {
                                        //this.sendEmailPoster(eventResponse.data.event.id);
                                    }
                                    sessionStorage.setItem('first_save_draft', false);
                                }

                                let validation = this.state.validation;
                                validation['venue']['name'].valid = true;
                                validation['venue']['address'].valid = true;
                                validation['venue']['city'].valid = true;
                                validation['venue']['zip'].valid = true;
                                validation['venue']['phone'].valid = true;
                                validation['venue']['max_seats'].valid = true;
                                validation['venue']['timezone'].valid = true;

                                this.setState({ 
                                    isReadyToSubmit: true,
                                    isEditMode:true,
                                    event : event,
                                    dates : dates,
                                    venueType,
                                    hasNotBeenSavedYet: false,
                                    validation,
                                });
                            }
                        } catch (error) {
                            console.log(error);
                        }
                    };

                    async function get_venue_event(venue_id) {
                        return await ApiRequest(`/venues/${venue_id}`, {
                            method: 'GET'
                        });
                    }

                    getVenueEvent();
                } else {
                    this.setMessage(window.general_strings.msg.oops, eventResponse.data.error.code, 'error');
                }
            } catch (error) {
                console.log(error);
                this.setMessage(window.general_strings.msg.oops, error, 'error');
            }
        };

        async function get_event(data) {
            return await ApiRequest(`/events/${event_id}`, {
                method: 'GET'
            });
        }

        getEvent();
    }

    populateFormElements = (addressComponent, formMap) => {
        const addressType = addressComponent.types[0];
        const event = { ...this.state.event };
        if (formMap.googleComponent === addressType) {
            let formValue = addressType === 'country' || addressType === 'administrative_area_level_1' ? addressComponent.short_name : addressComponent.long_name;
            if (addressType === 'street_number' || addressType === 'route') {
                event['venue'][formMap.id] += `${formValue} `;
            } else {
                event['venue'][formMap.id] = formValue;
            }
        }
        this.setState({ event });
    }

    populateEventDetails = (id) => {
        const event = {...this.state.event};
        const selectedMTIshow = event.details.existingMitShows.filter((show) => show.id === id)[0];

        // If VOD or Stream, must agree to MTI terms
        if (event.details.event_type === 'Video On Demand' || event.details.event_type === 'Live Stream' || event.details.event_type === 'Scheduled Content') {
            this.setState({
                selectedMTIshow,
                isMTIModalOpen: true,
            });
        } else {
            event['details']['mti_show_id'] = selectedMTIshow.id;
            event['details']['desc'] = selectedMTIshow.desc;
            event['details']['short_name'] = selectedMTIshow.short_name || selectedMTIshow.name;
            event['details']['name'] = selectedMTIshow.name;
            //event['details']['poster_graphic_url'] = event['details']['existingMitShows'][i].poster_graphic_url;
            event['details']['mti_show'] = true;
            this.setState({ event }, () => {
                //this.convertImgToBase64URL(event['details']['existingMitShows'][i].poster_graphic_url);
            });
            this.clearValidation('details');
        }
    }

    convertImgToBase64URL = (url) => {
        const _this = this;
        base64Img.requestBase64("https://cors-anywhere.herokuapp.com/" + url, function(err, res, body) {
            fetch(body)
                .then(res => res.blob())
                .then(blob => _this.uploadFile(url, 'details', 'poster_graphic_id', blob));
        });
    }

    handleChangeType = (e, _value) => {
        let value = _value;
        if (e) {
            e.persist();
            value = e.target.value;
        }
        
        const event = {...this.state.event};
        const wizard = {...this.state.wizard};

        // If VOD or Live Stream event, make the venue a General Admission
        // Put wizard default to -2
        if (value === 'Live Stream' || value === 'Video On Demand' || value === 'Scheduled Content') {
            event['venue']['venue_type'] = 'general-admission';
            event['venue']['sections'] = [{ id: 0, name: 'General Admission' }];
            event['venue']['status'] = 'pending';
            event['venue']['name'] = 'Stream Event';
            event['venue']['max_seats'] = 9999;
            if (value === 'Live Stream') {
                event['venue']['status'] = 'active';
                this.props.toggleSavePublishButton(false);
            } else {
                this.props.toggleSavePublishButton(event['venue']['status'] === 'pending');
            }
            wizard['public']['end_time'] = '-2';
        } else {
            event['venue']['venue_type'] = 'reserved-seating';
            event['venue']['sections'] = [];
            event['venue']['status'] = '';
            event['venue']['name'] = '';
            event['venue']['max_seats'] = 0;
            this.props.toggleSavePublishButton(event['venue']['status'] === '');

            wizard['public']['end_time'] = '2';
        }

        // Reset all venue information when changing type
        event['venue']['id'] = undefined;
        event['venue']['address'] = '';
        event['venue']['city'] = '';
        event['venue']['country'] = 'US';
        event['venue']['name'] = '';
        event['venue']['phone'] = '';
        event['venue']['sections'] = [];
        event['venue']['state'] = 'AL';
        event['venue']['timezone'] = '';
        event['venue']['zip'] = '';

        // Reset MTI search and fields
        event['details']['existingMitShows'] = [];
        event['details']['searchTerm'] = '';
        event['details']['desc'] = '';
        event['details']['short_name'] = '';
        event['details']['name'] = '';
        event['details']['mti_show'] = false;

        event.details.event_type = value;

        this.setState({ 
            event,
            wizard,
        });
    }

    handleChange = (e) => {
        e.persist();
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const name = e.target.name;
        if(name !== 'service_fee'){
            if (e.target.type === "radio") {
                (value === "true") ? value = true : value = false;
            }
        }
        
        const event = {...this.state.event};
        const wizard = {...this.state.wizard};

        // If VOD or Live Stream event, make the venue a General Admission
        // Put wizard default to -2
        if(name === 'event_type'){
            if (value === 'Live Stream' || value === 'Video On Demand' || value === 'Scheduled Content') {
                event['venue']['venue_type'] = 'general-admission';
                event['venue']['sections'] = [{ id: 0, name: 'General Admission' }];
                event['venue']['status'] = 'pending';
                event['venue']['name'] = 'Stream Event';
                this.props.toggleSavePublishButton(event['venue']['status'] === 'pending');

                wizard['public']['end_time'] = '-2';
            } else {
                event['venue']['venue_type'] = 'reserved-seating';
                event['venue']['sections'] = [];
                event['venue']['status'] = '';
                event['venue']['name'] = '';
                this.props.toggleSavePublishButton(event['venue']['status'] === '');

                wizard['public']['end_time'] = '2';
            }
        }

        if(name === 'venue_type' && value === 'general-admission'){
            event['venue']['sections'] = [{ id: 0, name: 'General Admission' }];
        }

        if(name === 'venue_type' && (value === 'reserved' || value === 'general-admission')){
            event['venue']['status'] = 'pending';
            this.props.toggleSavePublishButton(event['venue']['status'] === 'pending');
        }
        
        if (name === 'country') {
            if (event.venue.country === 'US') {
                event[key]['state'] = 'AB';
                event['venue']['timezone'] = '';
            } else {
                event[key]['state'] = 'AL';
                event['venue']['timezone'] = '';
            }
        }

        // If licensing house is DPS and access code doesn't start with SO_, add it to the value
        if (name === 'license_access_code') {
            if (event.details.licensing_house === 'DPS') {
                if (!value.startsWith('SO_')) {
                    value = `SO_${value}`;
                }
            }
        }

        // If timezone is set, remove validation = false
        let validation = this.state.validation;
        if (name === 'timezone' && value !== '') {
            validation['venue']['timezone'].valid = true;
            validation['venue']['timezone'].msg = '';
        }

        event[key][name] = value;
        this.setState({ 
            event,
            wizard,
            hasNotBeenSavedYet: true,
            validation,
        });
        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e);
        }
    }

    handleChangeWizard = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        let name = '';
        if(e.target.name !== ''){
            name = e.target.name;
        }

        const wizard = {...this.state.wizard};
        if(name !== ''){
            wizard[key][name] = value;
        } else {
            wizard[key] = value;
        }
    
        console.log(wizard)
        this.setState({ wizard });
    }

    handleChangeDateWizard = (value, key, name) => {
        const wizard = {...this.state.wizard};
        if(value === undefined) {
            value = null;
        }
        if(name){
            wizard[key][name] = value;
        } else {
            // Sort dates to have them in ascending order so it's easier to calculate other entries
            value.sort((a,b) => {
                var c = new Date(a);
                var d = new Date(b);
                return c-d;
            });
            wizard[key] = value;
        }

        // Check if public start date is AFTER presale end date
        if(wizard.presale.end_date !== null && wizard.public.start_date !== null){
            if(moment(wizard.presale.end_date) > moment(wizard.public.start_date)){
                this.setState({ isWizardError : true });
            } else {
                this.setState({ isWizardError : false });
            }
        } else {
            this.setState({ isWizardError : false });
        }
        this.setState({ wizard });
    }

    handleChangeVOD = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        let name = '';
        if(e.target.name !== ''){
            name = e.target.name;
        }

        let vod_date = {...this.state.vod_date};
        if(name !== ''){
            if (key !== '') {
                vod_date[key][name] = value;
            } else {
                vod_date[name] = value;
            }
        } else {
            vod_date[key] = value;
        }

        // Set the event time to same as Public End Time
        if (key === 'public' && name === 'start_time') {
            vod_date.time = value;
        }

        console.log(vod_date)
    
        this.setState({
            vod_date,
        }, () => {
            this.validateVODEvent();
        });
    }

    handleChangeDateVOD = (value, key, name) => {
        const vod_date = {...this.state.vod_date};
        if(value === undefined) {
            value = null;
        }
        if(name){
            vod_date[key][name] = value;
        } else {
            // Sort dates to have them in ascending order so it's easier to calculate other entries
            value.sort((a,b) => {
                var c = new Date(a);
                var d = new Date(b);
                return c-d;
            });
            vod_date[key] = value;
        }

        // Set the event date to same as Public End Date
        if (key === 'public' && name === 'start_date') {
            vod_date.date = value;
        }

        // Check if public start date is AFTER presale end date
        if(vod_date.presale.end_date !== null && vod_date.public.start_date !== null){
            if(moment(vod_date.presale.end_date) > moment(vod_date.public.start_date)){
                this.setState({ isWizardError : true });
            } else {
                this.setState({ isWizardError : false });
            }
        } else {
            this.setState({ isWizardError : false });
        }
        this.setState({
            vod_date,
        }, () => {
            this.createEventVOD(false);
            this.validateVODEvent();
        });
    }

    validateVODEvent = () => {
        let isReadyVOD = false;
        let vod_date = this.state.vod_date;
        if (vod_date.date) {
            //if (vod_date.presale.start_date) {
                //if (vod_date.presale.end_date) {
                    if (vod_date.public.start_date) {
                        if (vod_date.public.end_date) {
                            //if (vod_date.boxoffice.end_date) {
                                isReadyVOD = true;
                            //}
                        }
                    }
                //}
            //}
        }

        this.setState({
            isReadyVOD,
        });
    };

    handleSortableInputs = (e) => {
        e.persist();
        let value = e.target.value;
        let key = e.target.attributes.getNamedItem('object').value;
        let id = parseInt(e.target.attributes.getNamedItem('id').value, 0);
        let name = e.target.name;

        if (parseInt(value) < 0) {
            value = Math.abs(value);
        }

        let event = { ...this.state.event };
        var index = event[key].findIndex(x => x.id === id); //If we change id to artist_id, we need to figure out a way to treat this generic
        event[key][index][name] = value;
        this.setState({ 
            event,
            hasNotBeenSavedYet: true,
        });

        if (e.target.attributes.getNamedItem('validation')) {
            const validationRegEx = e.target.attributes.getNamedItem('validation').value;
            this.validate(value, key, name, validationRegEx, e, index);
        }
        this.checkIfAddRow(key);
    }

    handleSearch = async (e) => {
        const event = { ...this.state.event };
        
        try {
            if(event.details.searchTerm === ""){
                event['details']['existingMitShows'] = [];
                this.setState({ event });
            } else {

                // Pass the type of event?

                const response = await get_shows(event.details.searchTerm);
                console.log('response: ', response);
                if(response.data.shows){
                    if(response.data.shows.length > 0){
                        event['details']['existingMitShows'] = response.data.shows;
                        this.setState({ event });
                    } else {
                        this.setMessage(window.general_strings.msg.oops, "No shows were found.", 'error');
                        setTimeout(() => {
                            this.setMessage('', '', '');
                        }, 3000);
                    }
                } else {
                    this.setMessage(window.general_strings.msg.oops, response.data.error.code, 'error');
                    setTimeout(() => {
                        this.setMessage('', '', '');
                    }, 3000);
                }
            }
            
        } catch (error) {
            console.log(error);
        }
        

		async function get_shows(search) {
			return await ApiRequest(`/events/mti-search?search=${search}`, {
                method: 'GET'
			});
        }
    }

    handleLicensingHouse = (e) => {
        const event = { ...this.state.event };
        event.details.licensing_house = e.target.value;
        if (e.target.value === 'DPS') {
            event.details.license_access_code = 'SO_';
        } else {
            event.details.license_access_code = '';
        }
        this.setState({
            event,
        });
    }

    handleMTIAccessCode = async (value) => {
        const event = { ...this.state.event };
        this.setMessage('','','loading');
        try {
            if(event.details.license_access_code === ""){
                //event['details']['existingMitShows'] = [];
                //this.setState({ event });
            } else {
                const response = await checkAccessCode(event.details.license_access_code);
                
                let mti_access_result = response.data;

                if (mti_access_result.errors.indexOf('none') !== -1) {
                    this.setMessage('','','');
                    this.setState({
                        mti_access_result,
                    }, () => {
                        const eventType = this.state.event.details.event_type;
                        console.log(eventType)
                        if (!this.state.mti_access_result.licenseTypes || !this.state.mti_access_result.royalties) {
                            this.toggleModalMTIError();
                        } else {
                            if (eventType === 'Video On Demand') {
                                if (this.state.mti_access_result.licenseTypes.streamD === 'Y') {
                                    this.toggleModalMTI();
                                } else {
                                    this.toggleModalMTIError();
                                }
                            }
        
                            if (eventType === 'Live Stream') {
                                if (this.state.mti_access_result.licenseTypes.streamL === 'Y') {
                                    this.toggleModalMTI();
                                } else {
                                    this.toggleModalMTIError();
                                }
                            }
        
                            if (eventType === 'Scheduled Content') {
                                if (this.state.mti_access_result.licenseTypes.streamS === 'Y') {
                                    this.toggleModalMTI();
                                } else {
                                    this.toggleModalMTIError();
                                }
                            }
                        }

                        
                        
                    });
                } else {
                    this.setMessage(window.general_strings.msg.oops,mti_access_result.errors,'error');
                    window.scrollTo(0, 0);
                }
            }
            
        } catch (error) {
            console.log(error);
        }
        

		async function checkAccessCode(accessCode) {
			return await ApiRequest(`/mti/access-code`, {
                method: 'POST',
                data: {
                    accessCode,
                }
			});
        }
    }

    handleDPS = async (value) => {
        const event = { ...this.state.event };
        this.setMessage('','','loading');
        try {
            if (event.details.license_access_code === "") {
                //event['details']['existingMitShows'] = [];
                //this.setState({ event });
            } else {
                const response = await checkAccessCode(event.details.license_access_code);
                console.log('DPS Response', response);
                let dps_access_result = response.data;

                if (!dps_access_result.error) {
                    this.setMessage('','','');
                    this.setState({
                        dps_access_result,
                    }, () => {
                        this.toggleModalDPS();
                    });
                } else {
                    let error = strings.invalidDPSAccessCode;
                    this.setMessage(window.general_strings.msg.oops,error,'error');
                    window.scrollTo(0, 0);
                }
            }
            
        } catch (error) {
            console.log(error);
        }
        

		async function checkAccessCode(sales_order_number) {
			return await ApiRequest(`/dps/show-license-data`, {
                method: 'POST',
                data: {
                    sales_order_number,
                }
			});
        }
    }

    validate = (value, key, name, validationRegEx, e, index) => {
        const validation = { ...this.state.validation };
        const event = { ...this.state.event };
        let isValid = true;
        const re = new RegExp(validationRegEx);
        if (!re.test(value)) {
            if (key !== 'prices') {
                value === '' ? validation[key][name]['msg'] = strings.errorRequired : validation[key][name]['msg'] = strings.errorInvalid;
            }
            isValid = false;
        }

        if (key === 'prices' || key === 'fees') {
            event[key][index]['validation']['valid'] = isValid;
            this.setState({ event });
        } else {
            validation[key][name]['valid'] = isValid;
            this.setState({ validation }, () => { this.validateRequiredField(e) });
        }
    }

    validateRequiredField = (e) => {
        //console.log(e);
        const validation = {...this.state.validation};
        if (e.target.value === '' && e.target.attributes.getNamedItem('required')) {
            const key = e.target.attributes.getNamedItem('object').value;
            const name = e.target.name;
            const validation = { ...this.state.validation };
            validation[key][name]['msg'] = strings.errorRequired;
            validation[key][name]['valid'] = false;
        }
        this.setState({ validation }, () => this.validateAllRequiredFields());
    }

    getSum = (total, num) => {
        return total + num;
    }

    validateAllRequiredFields = () => {
        const validation = { ...this.state.validation };
        let isReadyToSubmit = { ...this.state.isReadyToSubmit };
        let arrValidation = Object.keys(validation).map((k) => validation[k]);
        let i = arrValidation.map((i) => { 
            return Object.keys(i).map((k) => i[k]);
        })
        .map((i) => { 
            return i.filter((l) => { 
                return typeof(l.valid) !== 'undefined'; 
            }).length; 
        })
        .reduce(this.getSum);
        
        for (let type in validation) {
            for (let field in validation[type]) {
                if (validation[type][field]['valid']) {
                    i--;
                }
            }
        }
        isReadyToSubmit = (i === 0);
        this.setState({ isReadyToSubmit });
    }


    loadVenues = () => {

        // Load all Venues
        const doGetVenues = async () => {
            try {
                const venuesResponses = await get_venues();
                console.log('venuesResponses', venuesResponses);

                if(venuesResponses.data.venues.length > 0){
                    let event = this.state.event;
                    let isStreamingEvent = false;
                    if (event.details.event_type === 'Video On Demand' || event.details.event_type === 'Live Stream' || event.details.event_type === 'Scheduled Content') {
                        isStreamingEvent = true;
                    }
                    if (!isStreamingEvent) {
                        event.venue.venue_type = 'existing';
                    }
					this.setState({ 
                        event,
                        venues:venuesResponses.data.venues
                    });
                }
            } catch (error) {
                console.log(error);
            }
        }

        async function get_venues() {
            return await ApiRequest(`/venues`, {
                method: 'GET'
            });
        }
		doGetVenues();
    }

    loadVenue = (e) => {
        this.setMessage('', '', 'loading');
        // Load Venue Event to get Sections
        const loadVenueInfo = async (venue_id) => {
            try {
                // Get Venue
                const venueResponse = await get_venue_info(venue_id);
                console.log('venueResponse', venueResponse);   

                if(venueResponse.data.venue) {
                    let event = { ...this.state.event };
                    event['venue']['venue_type'] = venueResponse.data.venue.venue_type;
                    event['venue']['id'] = venueResponse.data.venue.id;
                    event['venue']['name'] = venueResponse.data.venue.name;
                    event['venue']['address'] = venueResponse.data.venue.address;
                    event['venue']['city'] = venueResponse.data.venue.city;
                    event['venue']['state'] = venueResponse.data.venue.state;
                    event['venue']['zip'] = venueResponse.data.venue.zip;
                    event['venue']['phone'] = venueResponse.data.venue.phone;
                    event['venue']['timezone'] = venueResponse.data.venue.timezone;
                    event['venue']['max_seats'] = venueResponse.data.venue.max_seats;
                    event['venue']['chart'] = venueResponse.data.venue.seating_chart_id || 0;
                    event['venue']['status'] = venueResponse.data.venue.status;
                    this.props.toggleSavePublishButton(venueResponse.data.venue.status !== 'active');
                    if(typeof venueResponse.data.venue.sections !== 'undefined'){
                        let sections = [];
                        venueResponse.data.venue.sections.forEach((section) => {
                            let venueSection = {};
                            venueSection.id = section.id;
                            venueSection.name = section.name;
                            sections.push(venueSection);
                        });
                        event['venue']['sections'] = sections;
                    } else {
                        event['venue']['sections'] = [{ id: 0, name: 'General Admission' }];
                    }

                    // Force new prices for dates
                    let pricesArr = [];
                    event['venue']['sections'].forEach((section, i) => {
                        if(event.prices.length > 1){
                            event.prices.forEach((price) => {
                                let priceObj = {};
                                priceObj.section = section.id;
                                priceObj.price = price.id;
                                priceObj.value = 'all';
                                console.log('priceObj', priceObj)
                                // if price is new and value is 0, make it box office only
                                if (priceObj.isNew && parseInt(priceObj.amount, 10) === 0) {
                                    priceObj.value = "box-office";
                                }
                                pricesArr.push(priceObj);
                            });
                        }
                    });
                    let dates = [...this.state.dates];
                    dates.forEach((date) => {
                        date.prices = pricesArr;
                    });

                    this.setState({ event });
                    this.clearValidation('venue');
                    this.setMessage('', '', '');
                }
            } catch (error) {
                console.log(error);
            }
        };

        async function get_venue_info(venue_id) {
            return await ApiRequest(`/venues/${venue_id}`, {
                method: 'GET'
            });
        }

        if(e.target.value) {
            loadVenueInfo(parseInt(e.target.value, 0));
        } else {
            this.setMessage('', '', '');
        }
    }

    clearValidation = (type) => {
        let validation = { ...this.state.validation };
        let validationType = validation[type];  
        for (let field in validationType) {
            validationType[field]['valid'] = true;
            validationType[field]['msg'] = '';
        }
        validation[type] = validationType;
        this.setState({ validation });
    }

    clearVenue = () => {
        let event = { ...this.state.event };
        event['venue']['type'] = "";
        event['venue']['id'] = undefined;
        event['venue']['name'] = "";
        event['venue']['address'] = "";
        event['venue']['city'] = "";
        event['venue']['state'] = "AL";
        event['venue']['zip'] = "";
        event['venue']['phone'] = "";
        event['venue']['timezone'] = "";
        event['venue']['max_seats'] = 0;
        event['venue']['chart'] = 0;
        event['venue']['sections'] = [];
        event['venue']['status'] = 'pending';

		this.setState({ event });
    }

    clearSelectedShow = () => {
        const event = {...this.state.event};
        event['details']['desc'] = "";
        event['details']['short_name'] = "";
        event['details']['name'] = "";
        event['details']['poster_graphic_url'] = "";
        event['details']['poster_graphic_id'] = null;
        event['details']['mti_show'] = false;
        event['details']['searchTerm'] = "";
        event['details']['existingMitShows'] = [];
        this.setState({ event });
        this.clearValidation('details');
    }

    updateFile = (data, key, name) => {
        const event = { ...this.state.event };
        event[key][name] = data.upload.id;
        this.setState({ 
            event,
            hasNotBeenSavedYet: true,
        }, 
        () => {
            this.setMessage('','','');
        });
    }

    uploadFile = (file, key, name, croppedFile) => {
        this.setMessage('','','loading');
        (async () => {
            try {
                let uploadFileResponse;
                if(name === 'chart') {
                    uploadFileResponse = await uploadFile(file);
                } else {
                    uploadFileResponse = await uploadFile(croppedFile);
                }
                
                if(uploadFileResponse.data.upload){
                    this.updateFile(uploadFileResponse.data, key, name);
                } else {
                    this.setMessage(window.general_strings.msg.oops,strings.msg.wrong,'error');
                }
                
            } catch (error) {
                console.log(error);
            }
        })()

        async function uploadFile(file) {
            const formData = new FormData();
            formData.append('file', file);

            return await ApiRequest('/uploads', {
                method: 'POST',
                contentType: 'multipart/form-data',
                data: formData
            });
        }
    }

    clearFile = (e) => {
        const event = { ...this.state.event };
        event['details'][e.target.getAttribute('objectname')] = '';
        this.setState({ event });
    }

    checkIfAddRow = (key) => {
        const event = {...this.state.event};
        let noEmptyValues = true;
        event[key].forEach((obj, index) => {
            for (let o in obj) {
                if (obj[o] === '') {
                    noEmptyValues = (o === 'position');
                    break;
                } 
            }
            noEmptyValues ? obj['delete'] = true : obj['delete'] = false;
            this.setState({ event });
        });

        noEmptyValues && this.addRow(key);
	}

	addRow = (key) => {
        const event = {...this.state.event};
        const obj = Object.assign({}, event[key][0]);

        for (let o in obj) {
            if (o === 'id') {
                obj[o] = Date.now();
            }
            else if (o === 'validation') {
                obj[o] = {
                    name: '',
                    price: ''
                };
            }
            else {
                obj[o] = '';
            }
        }
        obj['delete'] = false;
        obj['isNew'] = true;
        event[key].push(obj); 
        this.setState({ 
            event,
            hasNotBeenSavedYet: true
        });

        //if (key === 'prices') {
            //this.addNewDatePricing();
            //if(previousPrices < prices.length) {
            //    alert('a new price has been created.')
            //}
        //}
    }

    addNewDatePricing = () => {
        const prices = this.state.event.prices;
        const sections = this.state.event.venue.sections;
        const dates = this.state.dates;
        prices.forEach((price) => {
            if (price.isNew && price.amount >= 0 && price.desc !== '') {
                dates.forEach((date) => {
                    sections.forEach((section) => {
                        let priceObject = {};
                        priceObject.price = price.id;
                        priceObject.section = section.id;
                        priceObject.value = 'all';
                        console.log('priceObject', priceObject)
                        // if price is new and value is 0, make it box office only
                        if (priceObject.isNew && parseInt(priceObject.amount, 10) === 0) {
                            priceObject.value = "box-office";
                        }
                        date.prices.push(priceObject)
                    });
                });
            }
        });
        this.setState({
            dates,
            hasNotBeenSavedYet: true,
        });
    }

    deleteRow = (e) => {
        const key = e.target.attributes.getNamedItem('object').value;
        const id = parseInt(e.target.id, 0);
        const event = {...this.state.event};

        console.log('event.isPublished', event.isPublished);
        console.log('jey', key);
        if (event.isPublished) {
            if (key === 'prices') {
                this.setState({
                    priceToDelete: id
                });
                this.toggleConfirmDeletePrice(true);
            }
        } else {
            if (event.details.status !== 'active') {
                var index = event[key].findIndex(x => x.id === id);
                event[key].splice(index,1);
                this.setState({ 
                    event,
                    hasNotBeenSavedYet: true
                });
            }
        }
	}

	onSortEnd = ({oldIndex, newIndex}, e) => {
        if(oldIndex !== newIndex){
            const event = { ...this.state.event };
            const currentDragTable = this.state.currentDragTable;
            event[currentDragTable] = arrayMove(event[currentDragTable], oldIndex, newIndex)
            this.setState({ event }, () => {
                if(currentDragTable === 'prices'){
                    const dates = [...this.state.dates];
                    let prices_orders = [];
                    event['prices'].forEach((price, price_index) => {
                        if(price.delete){
                            prices_orders.push(price.id);
                        }
                    });
                    dates.forEach((date) => {
                        let new_date_prices = [];
                        for(var i=0; i<prices_orders.length;i++){
                            for(var j=0; j<date.prices.length;j++){
                                if(date.prices[j].price === prices_orders[i]){
                                    new_date_prices.push(date.prices[j]);
                                }
                            }
                        }
                        date.prices = new_date_prices;
                    });
                    this.setState({ 
                        dates,
                        hasNotBeenSavedYet: true
                    });
                }
            });
        }
    };

    onSortStart = ({node}) => {
        const currentDragTable = GetNearestTableAncestorId(node);
        this.setState({ currentDragTable });
    };
    
    toggleConfirmDeletePrice = (value) => {
		this.setState({
			isConfirmDeletePriceOpen: value
		});
    }

    toggleConfirmGlobalChange = (value) => {
		this.setState({
			isConfirmGlobalChangeOpen: value
		});
    }
    
    confirmDeletePrice = () => {
        const dates = [...this.state.dates];
        dates.forEach((date, i) => {
            date['prices'].forEach((price, j) => {
                if(parseInt(price.price, 0) === this.state.priceToDelete){
                    price.value = 'hidden';
                }
            });
        });
        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        });
    }

    toggleDatesModal = (e) => {
        let eventId = '';
        let prices = [...this.state.wizard.prices];
        if (this.state.event.details.event_type !== 'Video On Demand') {
            if(typeof e !== 'undefined'){
                if(e.currentTarget.id !== ''){
                    eventId = parseInt(e.currentTarget.id, 10);
                    prices = this.state.dates[eventId].prices;
                }
            }
        } else {
            if(typeof e !== 'undefined'){
                if(e.currentTarget.id !== ''){
                    eventId = parseInt(e.currentTarget.id, 10);
                    prices = this.state.dates[eventId].prices;
                }
            }
        }
        this.setState({
            isDatesModalOpen: !this.state.isDatesModalOpen,
            eventToModify: eventId,
            prices: prices
        });
    }

    toggleGlobalPriceModal = (e) => {
        let eventId = '';
        let prices = [...this.state.wizard.prices];
        if (this.state.event.details.event_type !== 'Video On Demand') {
            if(typeof e !== 'undefined'){
                if(e.currentTarget.id !== ''){
                    eventId = parseInt(e.currentTarget.id, 10);
                    prices = this.state.dates[eventId].prices;
                }
            }
        }
        this.setState({
            isGlobalPriceModalOpen: !this.state.isGlobalPriceModalOpen,
            eventToModify: eventId,
            prices: prices
        });
    }

    saveGlobalPricing = () => {
        const inputs = document.querySelectorAll('.js-section-global-price');
        const prices = this.state.event.prices;
        const dates = [...this.state.dates];
        const sections = this.state.event.venue.sections;
        const event = this.state.event;
        let vod_date = this.state.vod_date;
        let pricesArr = [];
        inputs.forEach((input, i) => {
            const value = input.value;
            if(input.value !== "null"){
                const section = input.attributes.getNamedItem('section').value;
                const price = input.attributes.getNamedItem('price').value;

                let priceObj = {};
                priceObj.section = parseInt(section);
                priceObj.price = parseInt(price);
                priceObj.value = value;
                pricesArr.push(priceObj);
            }
        });

        console.log('pricesArr', pricesArr);
        
        if (event.details.event_type !== 'Video On Demand') {
            dates.forEach((date, index_date) => {
                console.log('date', date);
    
                // if no price change, check if prices and date prices are the same amount
                if (pricesArr.length === 0) {
                    // if prices are higher than the date pricing, create missing date prices
                    //if ((prices.length - 1) > date.prices.length) {
    
                        let missingPrices = prices.filter( function( item ) {
                            for( var i=0, len=date.prices.length; i<len; i++ ){
                                if( date.prices[i].price == item.id ) {
                                    return false;
                                }
                            }
                            return true;
                        });
                        console.log(missingPrices);
    
                        let newDatePrices = date.prices;
    
                        missingPrices.forEach((missingPrice) => {
                            if (missingPrice.delete) {
                                sections.forEach((section) => {
                                    let priceObj = {};
                                    priceObj.section = parseInt(section.id);
                                    priceObj.price = parseInt(missingPrice.id);
                                    priceObj.value = 'all';
                                    console.log('priceObj', priceObj)
                                    // if price is new and value is 0, make it box office only
                                    if (priceObj.isNew && parseInt(priceObj.amount, 10) === 0) {
                                        priceObj.value = "box-office";
                                    }
                                    newDatePrices.push(priceObj);
                                });
                            }
                        });
    
                        date.prices = newDatePrices;
                    //}
                }
    
                console.log('pricesArr', pricesArr);
                let count = 0;

                // Check for missing prices for each date and add them if missing
                // Global Pricing bug #1600
                let missingPrices = pricesArr.filter( function( item ) {
                    for( var i=0, len=date.prices.length; i<len; i++ ){
                        if(parseInt(date.prices[i].price, 10) == parseInt(item.price, 10) && parseInt(date.prices[i].section, 10) == parseInt(item.section, 10)) {
                            return false;
                        }
                    }
                    return true;
                });
                console.log('missingPrices', missingPrices);

                missingPrices.forEach((missingPrice) => {
                    dates[index_date]['prices'].push(missingPrice);
                });
                // [end] Check for missing prices for each date and add them if missing

                
                for(let i = 0; i < date.prices.length; i++) {
                    for(let j = 0; j < pricesArr.length; j++) {
                        console.log('date.prices', date.prices);
                        if(parseInt(date.prices[i].price) === parseInt(pricesArr[j].price)) {
                            console.log('price is there');
                            count++;
                        } else {
                            console.log('price is not there');
                        }

                        if(parseInt(date.prices[i].section) === parseInt(pricesArr[j].section) && parseInt(date.prices[i].price) === parseInt(pricesArr[j].price)){
                            dates[index_date]['prices'][i].value = pricesArr[j].value;
                            console.log('i', dates[index_date]['prices'][i])
                            // if price is new and value is 0, make it box office only
                            if (pricesArr[j].isNew && parseInt(pricesArr[j].amount, 10) === 0) {
                                dates[index_date]['prices'][i].value = "box-office";
                            }
                        }
                    }
                }
                console.log('count', count)
    
                if(count === 0) {
                    for(let j = 0; j < pricesArr.length; j++) {
                        let newPricingOption = {};
                        newPricingOption.section = parseInt(pricesArr[j].section);
                        newPricingOption.price = parseInt(pricesArr[j].price);
                        newPricingOption.value = pricesArr[j].value;
                        console.log('newPricingOption', newPricingOption)
                        // if price is new and value is 0, make it box office only
                        if (pricesArr[j].isNew && parseInt(pricesArr[j].amount, 10) === 0) {
                            newPricingOption.value = "box-office";
                        }
                        dates[index_date]['prices'].push(newPricingOption);
                    }
                }
            });
        } else {
            // if no price change, check if prices and date prices are the same amount
            if (pricesArr.length === 0) {
                let missingPrices = prices.filter( function( item ) {
                    for( var i=0, len=vod_date.prices.length; i<len; i++ ){
                        if( vod_date.prices[i].price == item.id ) {
                            return false;
                        }
                    }
                    return true;
                });
                console.log('missingPrices', missingPrices);

                let newDatePrices = vod_date.prices;

                missingPrices.forEach((missingPrice) => {
                    if (missingPrice.delete) {
                        sections.forEach((section) => {
                            let priceObj = {};
                            priceObj.section = parseInt(section.id);
                            priceObj.price = parseInt(missingPrice.id);
                            priceObj.value = 'all';
                            console.log('priceObj', priceObj)
                            // if price is new and value is 0, make it box office only
                            if (priceObj.isNew && parseInt(priceObj.amount, 10) === 0) {
                                priceObj.value = "box-office";
                            }
                            newDatePrices.push(priceObj);
                        });
                    }
                });
                vod_date.prices = newDatePrices;
            }
            vod_date.prices = pricesArr;
        }
        
        this.setState({ 
            dates,
            vod_date,
            hasNotBeenSavedYet: true
        });
        this.setState({
            isGlobalPriceModalOpen: false
        });
    }

    assignPricingToAll = () => {
        const dates = [...this.state.dates];
        const prices = [...this.state.wizard.prices];
        for(let date in dates){
            dates[date].prices = prices;
        }
        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        });
    }

    createEvents = () => {
        const wizard = {...this.state.wizard};
        let dates = [...this.state.dates];
        //dates = [];
        for(let date in wizard['dates']){
            let event = {};
            event.date = wizard['dates'][date].toString();
            event.time = wizard['time'];

            event.presale = {};
            if(wizard['presale']['start_date'] === null){
                event.presale.start_date = wizard['dates'][date].toString().substring(0,15);
            } else {
                event.presale.start_date = wizard['presale']['start_date'].toString().substring(0,15);
            }
            event.presale.start_time = wizard['presale']['start_time'];
            if(wizard['presale']['end_date'] === null){
                event.presale.end_date = wizard['dates'][date].toString().substring(0,15);
            } else {
                event.presale.end_date = wizard['presale']['end_date'].toString().substring(0,15);
            }
            event.presale.end_time = wizard['presale']['end_time'];
            event.presale.presale_password = wizard['presale']['password'];

            event.public = {};
            if(wizard['public']['start_date'] === null){
                event.public.start_date = wizard['dates'][date].toString().substring(0,15);
            } else {
                event.public.start_date = wizard['public']['start_date'].toString().substring(0,15);
            }
            event.public.start_time = wizard['public']['start_time'];
            event.public.end_date = wizard['dates'][date].toString().substring(0,15);
            event.public.end_time = wizard['public']['end_time'];

            /* event.boxoffice = {};
            event.boxoffice.end_date = wizard['dates'][date].toString().substring(0,15);
            event.boxoffice.end_time = wizard['boxoffice']['end_time']; */

            event.prices = [];
            if(this.state.wizard.prices.length > 0){
                event.prices = [...this.state.wizard.prices];
            } else {
                let section_pricings = [];
                const sections = [...this.state.event.venue.sections];
                const prices = [...this.state.event.prices];
                sections.forEach((section) => {
                    prices.forEach((price) => {
                        if(price.delete){
                            let section_pricing = {};
                            section_pricing.section = parseInt(section.id);
                            section_pricing.value = "all";
                            section_pricing.price = parseInt(price.id);
                            // if price is new and value is 0, make it box office only
                            if (price.isNew && parseInt(price.amount, 10) === 0) {
                                section_pricing.value = "box-office";
                            }
                            section_pricings.push(section_pricing);
                            
                        }
                    });
                });
                event.prices = section_pricings;
            }
            dates.push(event);
        }

        wizard['dates'] = [];
        this.setState({ 
            dates,
            hasNotBeenSavedYet: true,
            wizard,
        },
        () => {
            this.savePricing();
            const el = document.querySelector('#your-event-dates');
            const top = el.offsetTop - el.scrollTop + el.clientTop;
            window.scrollTo(0, top);
        });
    }

    validateVODEventDate = () => {
        const vod_date = {...this.state.vod_date};
        const event = this.state.event;
        if (event.details.event_type === 'Video On Demand') {
            if (!vod_date['date'] || !vod_date['public']['start_date'] || !vod_date['public']['end_date'] || !vod_date['redeem']['start_date'] || !vod_date['redeem']['end_date']) {
                this.setMessage(window.general_strings.msg.oops, 'Make sure that all required (*) event dates are filled out properly.', 'error');
                window.scrollTo(0, 0);
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    createEventVOD = (isShowMessage) => {
        const vod_date = {...this.state.vod_date};
        let dates = [];
        let event = {};
        
        event.presale = {};
        event.id = vod_date.id;
        event.event_subtitle = vod_date.event_subtitle;

        // Presale
        if(vod_date['presale']['start_date'] === null){
            if (vod_date['date'] !== null) {
                event.presale.start_date = vod_date['date'].toString().substring(0,15);
            }
        } else {
            event.presale.start_date = vod_date['presale']['start_date'].toString().substring(0,15);
        }
        if (vod_date['presale']['start_time'] !== null) {
            event.presale.start_time = vod_date['presale']['start_time'];
        }
        if(vod_date['presale']['end_date'] === null){
            if (vod_date['date'] !== null) {
                event.presale.end_date = vod_date['date'].toString().substring(0,15);
            }
        } else {
            event.presale.end_date = vod_date['presale']['end_date'].toString().substring(0,15);
        }
        if (vod_date['presale']['end_time'] !== null) {
            event.presale.end_time = vod_date['presale']['end_time'];
        }
        event.presale.presale_password = vod_date['presale']['presale_password'];

        // Redeem
        event.redeem = {};
        if(vod_date['redeem']['start_date'] === null){
            if (vod_date['date'] !== null) {
                event.redeem.start_date = vod_date['date'].toString().substring(0,15);
            }
        } else {
            event.redeem.start_date = vod_date['redeem']['start_date'].toString().substring(0,15);
        }
        if (vod_date['redeem']['start_time'] !== null) {
            event.redeem.start_time = vod_date['redeem']['start_time'];
        }
        if(vod_date['redeem']['end_date'] === null){
            /* if (vod_date['boxoffice']['end_date'] !== null) {
                event.redeem.end_date = vod_date['boxoffice']['end_date'].toString().substring(0,15);
            } */
        } else {
            event.redeem.end_date = vod_date['redeem']['end_date'].toString().substring(0,15);
            event.date = vod_date['redeem']['end_date'].toString().substring(0,15);
        }
        if (vod_date['redeem']['end_time'] !== null) {
            event.redeem.end_time = vod_date['redeem']['end_time'];
            event.time = vod_date['redeem']['end_time'];
        }

        // Public
        event.public = {};
        if(vod_date['public']['start_date'] === null){
            if (vod_date['date'] !== null) {
                event.public.start_date = vod_date['date'].toString().substring(0,15);
            }
        } else {
            event.public.start_date = vod_date['public']['start_date'].toString().substring(0,15);
        }
        if (vod_date['public']['start_time'] !== null) {
            event.public.start_time = vod_date['public']['start_time'];
        }

        if(vod_date['public']['end_date'] === null){
            if (vod_date['date'] !== null) {
                event.public.end_date = vod_date['date'].toString().substring(0,15);
            }
        } else {
            /* event.date = vod_date['public']['end_date'].toString().substring(0,15);
            if (vod_date['public']['end_time'] !== null) {
                event.time = vod_date['public']['end_time'];
            } */
            event.public.end_date = vod_date['public']['end_date'].toString().substring(0,15);
        }
        if (vod_date['public']['end_time'] !== null) {
            event.public.end_time = vod_date['public']['end_time'];
        }

        /* event.boxoffice = {};
        if (vod_date['boxoffice']['end_date'] !== null) {
            event.boxoffice.end_date = vod_date['boxoffice']['end_date'].toString().substring(0,15);
        }
        if (vod_date['boxoffice']['end_time'] !== null) {
            event.boxoffice.end_time = vod_date['boxoffice']['end_time'];
        } */

        event.prices = [];
        if(this.state.dates.length > 0){
            event.prices = [...this.state.dates[0].prices];
        } else {
            let section_pricings = [];
            const sections = [...this.state.event.venue.sections];
            const prices = [...this.state.event.prices];
            sections.forEach((section) => {
                prices.forEach((price) => {
                    if(price.delete){
                        let section_pricing = {};
                        section_pricing.section = parseInt(section.id);
                        section_pricing.value = "all";
                        section_pricing.price = parseInt(price.id);
                        // if price is new and value is 0, make it box office only
                        if (price.isNew && parseInt(price.amount, 10) === 0) {
                            section_pricing.value = "box-office";
                        }
                        section_pricings.push(section_pricing);
                        
                    }
                });
            });
            event.prices = section_pricings;
        }
        dates.push(event);

        //console.log('createEventVOD', event);
        //console.log('dates', dates);

        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        },
        () => {
            if(isShowMessage) {
                this.setMessage(window.general_strings.msg.yay, 'Your event dates have been created. You can now press Save a draft or Publish your event.', 'success');
                //this.savePricing();
                //const el = document.querySelector('#your-event-dates');
                //const top = el.offsetTop - el.scrollTop + el.clientTop;
                window.scrollTo(0, 0);
            }
        });
    }

    savePricing = () => {
        const event = this.state.eventToModify;
        if(event !== ''){
            this.setPricing(event);
        } else {
            this.setPricing();
        }
        this.setState({
            isDatesModalOpen: false
        });
    }

    setPricing = (event) => {
        const inputs = document.querySelectorAll('.js-section-price');
        let pricesArr = [];
        inputs.forEach((input, i) => {
            const value = input.value;
            const section = input.attributes.getNamedItem('section').value;
            const price = input.attributes.getNamedItem('price').value;

            let priceObj = {};
            priceObj.section = section;
            priceObj.price = price;
            priceObj.value = value;

            pricesArr.push(priceObj);
        });

        // No event, so push prices to Wizard
        if(typeof event === 'undefined'){
            const wizard = {...this.state.wizard};
            wizard['prices'] = pricesArr;
            this.setState({ wizard });
        } else {
            // Event id to edit, so update the event prices
            const dates = [...this.state.dates];
            dates[event].prices = pricesArr;
            this.setState({ 
                dates,
                hasNotBeenSavedYet: true
            });
        }
    }

    handleChangeEvent = (e) => {
        let value = e.target.value;
        const key = e.target.attributes.getNamedItem('object').value;
        const eventIndex = e.target.attributes.getNamedItem('event').value;
        let name = '';
        if(e.target.name !== ''){
            name = e.target.name;
        }

        const dates = [...this.state.dates];
        if(name !== ''){
            dates[eventIndex][key][name] = value;

            // Remove Sales Closed
            /* if(name === 'end_time' && key === 'boxoffice' && value !== '-1000'){
                dates[eventIndex][key]['end_date'] = '';//dates[eventIndex]['date'];
            }
            if(name === 'end_time' && key === 'boxoffice' && value === '-1000'){
                dates[eventIndex][key]['end_date'] = moment.utc().subtract(1, 'days').toDate();//dates[eventIndex]['date'];
            } */
            if(name === 'end_time' && key === 'public' && value !== '-1000'){
                dates[eventIndex][key]['end_date'] = '';//dates[eventIndex]['date'];
            }
            if(name === 'end_time' && key === 'public' && value === '-1000'){
                dates[eventIndex][key]['end_date'] = moment.tz(moment.utc(), this.state.event.venue.timezone).subtract(1, 'days').toDate();//dates[eventIndex]['date'];
            }
        } else {
            dates[eventIndex][key] = value;
        }
    
        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        });
    }

    handleChangeDateEvent = (value, key, name, eventIndex) => {
        const dates = [...this.state.dates];
        if(!value){
            value = moment.utc().toDate();
        }
        if(name){
            dates[eventIndex][key][name] = value;
        } else {
            dates[eventIndex][key] = value;
        }
        

        // if date of event changes, change also the public end date and box office end date
        if(key === "date"){
            dates[eventIndex]['public']['end_date'] = value;
        }
        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        });
    }

    toggleConfirmDeleteEvent = (e) => {
        this.setState({
            eventToDelete: e.currentTarget.id,
            isConfirmDeleteEventOpen: !this.state.isConfirmDeleteEventOpen
        });

        if(!this.state.event.isPublished){
            this.setState({
                modalDescription: strings.modalDescriptionDeleteEvent,
                modalButton: strings.delete
            });
        } else {
            // If event is published, put Sale end time in the past
            this.setState({
                modalDescription: strings.modalDescriptionDeleteEventPublished,
                modalButton: strings.stopSales
            });
        }
    }

    confirmConfirmDeleteEvent = () => {
        const dates = [...this.state.dates];
        // If event is not published, just remove event date and time
        if(!this.state.event.isPublished){
            dates.splice(this.state.eventToDelete,1);
        } else {
            // If event is published, put Sale end time in the past
            dates[this.state.eventToDelete]['public']['end_time'] = -1000;
            dates[this.state.eventToDelete]['public']['end_date'] = moment.tz(moment.utc(), this.state.event.venue.timezone).subtract(1, 'days').toDate();
        }

        this.setState({ 
            dates,
            hasNotBeenSavedYet: true
        });
        this.setState({
            isConfirmDeleteEventOpen: false
        });
    }

    handleVenueAddressChange = (value) => {
        const validation = this.state.validation;
        const event = this.state.event;
        validation['venue']['address']['valid'] = true;
        validation['venue']['address']['msg'] = '';
        event.venue.address = value;
        this.setState({
            event,
            validation,
        });
    }

    handleFullVenueAddressChange = (value) => {
        const { event } = this.state;
        const { validation } = this.state;
        event['venue']['address'] = `${value.address}`;
        event['venue']['city'] = `${value.city}`;
        event['venue']['country'] = `${value.country}`;
        event['venue']['state'] = `${value.state}`;
        event['venue']['zip'] = `${value.zip}`;

        if (!value.address) {
            event['venue']['address'] = ``;
        }
        // New Venue time zone #1154
        // If Virgin Islands
        if (value.country === 'VI') {
            event['venue']['country'] = `US`;
            event['venue']['state'] = `${value.country}`;
        }
        validation['venue']['address']['valid'] = true;
        validation['venue']['city']['valid'] = true;
        validation['venue']['country']['valid'] = true;
        validation['venue']['state']['valid'] = true;
        validation['venue']['zip']['valid'] = true;
        this.setState({
            event,
            validation
        }, () => {
            this.validateAllRequiredFields();
        });
    }

    componentDidMount() {
        this.props.toggleEventDraftButton(false);
        this.props.toggleSavePublishButton(true);
        this.checkIfAddRow('artists'); 
        this.checkIfAddRow('prices');

        // If event ID has been passed
        const params = this.props.routeProps.match.params;
        if (params && params.id) {
            this.getActiveEvent(params.id, false);
            this.setState({
                event_id: params.id,
            });
        }

        // Load all venues
        this.loadVenues(); 

        // Get event type
        let search = getUrlParams(window.location.search);
        //const { event } = this.state;
        if (search.type === 'vod') {
            this.handleChangeType(undefined, 'Video On Demand');
        }
        if (search.type === 'stream') {
            this.handleChangeType(undefined, 'Live Stream');
        }
        if (search.type === 'broadcast') {
            this.handleChangeType(undefined, 'Scheduled Content');
        }


        // Get current client
        (async () => {
            try {
                const response = await getCurrentClient();
                console.log('Current Client Response: ', response);
                this.setState({ client: response.data.client || {} });
            } catch (error) {
                console.log(error);
            }
        })()

        async function getCurrentClient() {
            return await ApiRequest('/clients/current');
        }
    }

    validateAllFields = () => {
        var inputs = [].slice.call(document.querySelectorAll("[validation][required='true']"));
        inputs.forEach((input) => {
            if(typeof input !== 'undefined' && input.name !== 'amount' && input.name !== 'desc'){
                this.validate(input.value, input.attributes.getNamedItem('object').value, input.name, input.attributes.getNamedItem('validation').value)
            }
        });
    }

    checkIfReadyToSubmit = () => {
        let numberOfRequired = 12;
        const eventDetails = {...this.state.event.details};
        const eventDetailsRequiredArray = ['event_type', 'name', 'contact_phone', 'contact_email'];
        const eventVenue = {...this.state.event.venue};
        const eventVenueRequiredArray = ['name', 'address', 'city', 'state', 'zip', 'phone', 'timezone'];
        const pricesArray = [...this.state.event.prices];
        const datesArray = [...this.state.dates];
        numberOfRequired += datesArray.length;

        eventDetailsRequiredArray.forEach((required) => {
            if(eventDetails[required] !== '' && eventDetails[required] !== undefined){
                numberOfRequired--;
            }
        });

        eventVenueRequiredArray.forEach((required) => {
            if(eventVenue[required] !== '' && eventVenue[required] !== undefined){
                numberOfRequired--;
            }
        });
        if(pricesArray.length > 0) {
            numberOfRequired--;
        };
        datesArray.forEach((date) => {
            if((date['public']['start_date'] !== '' && date['public']['start_date'] !== undefined) && (date['date'] !== '' && date['date'] !== undefined)){
                numberOfRequired--;
            }
        });

        let isReadyToSubmit = {...this.state.isReadyToSubmit};
        isReadyToSubmit = (numberOfRequired === 0);
        this.setState({ isReadyToSubmit });
    }

    clearImage = (e) => {
        const event = {...this.state.event};
        event['details'][e.target.getAttribute('objectid')] = "null";
        event['details'][e.target.getAttribute('objecturl')] = "";
        this.setState({ event });
    }

    componentWillReceiveProps(props) {
        if(props.saveEventMode !== ''){
            // Clear Save Event mode to avoid duplicate call
            this.props.clearSaveEventMode();
            this.setMessage('', '', 'loading');

            this.checkIfReadyToSubmit();

            let validation = this.state.validation;
            validation['venue']['name']['msg'] = '';
            validation['venue']['name']['valid'] = true;
            validation['venue']['address']['msg'] = '';
            validation['venue']['address']['valid'] = true;
            validation['venue']['city']['msg'] = '';
            validation['venue']['city']['valid'] = true;
            validation['venue']['zip']['msg'] = '';
            validation['venue']['zip']['valid'] = true;
            validation['venue']['phone']['msg'] = '';
            validation['venue']['phone']['valid'] = true;
            validation['venue']['timezone']['msg'] = '';
            validation['venue']['timezone']['valid'] = true;
            validation['venue']['max_seats']['msg'] = '';
            validation['venue']['max_seats']['valid'] = true;
            this.setState({
                validation,
            });

            setTimeout(() => {
                // Set is_public
                let is_public = false;
                props.saveEventMode === 'save' ? is_public = true : is_public = false;
                props.saveEventMode === 'draft' ? this.setState({ isReadyToSubmit:true }) : null;

                // Set method, if existing event, method will be PUT
                let method;
                (typeof this.props.routeProps.match.params.id !== 'undefined') ? method = "PUT" : method = "POST";
                
                // Not first time save draft
                if (method === "POST") {
                    sessionStorage.setItem('first_save_draft', true);
                } 

                // Set URL, if existing event, URL will contain event_id
                let url;
                (typeof this.props.routeProps.match.params.id !== 'undefined') ? url = `/events/${this.props.routeProps.match.params.id}` : url = "/events";
                const event = {...this.state.event};


                // Create event date based on the Wizard for VOD
                const isVodEventDateExist = this.validateVODEventDate();
                //console.log('isVodEventDateExist', isVodEventDateExist)
                if (event.details.event_type === 'Video On Demand' && isVodEventDateExist) {
                    let _this = this;
                    
                    const beforePost = async () => {
                        try {
                            _this.createEventVOD(true);
                        }
                        catch (error) {
                            console.log(error);
                        }
                    }
                    
                    beforePost();
                }

                // Create Pricing Options ready to be sent to API
                const pricing_options = [];
                event.prices.forEach((obj) => {
                    if(obj.desc !== ''){
                        const pricing_option = {};
                        pricing_option.desc = obj.desc;
                        const amount = Number(obj.amount);
                        pricing_option.amount = amount;
                        //if(!obj.isNew){
                            pricing_option.id = parseInt(obj.id)
                        //}
                        pricing_option.is_new = obj.isNew;
                        pricing_option.type = event.details.event_type;
                        pricing_options.push(pricing_option);
                    }
                });

                // Create Fees ready to be sent to API
                const fees = [];
                event.fees.forEach((obj) => {
                    if(obj.desc !== ''){
                        const fee = {};
                        fee.desc = obj.desc;
                        const amount = Number(obj.amount);
                        fee.amount = amount;
                        if(!obj.isNew){
                            fee.id = parseInt(obj.id)
                        }
                        fees.push(fee);
                    }
                });

                // Create Artists
                const artists = [];
                event.artists.forEach((obj) => {
                    if(obj.delete){
                        const artist = {};
                        if(!obj.isNew) {
                            artist.id = obj.id;
                        } else {
                            artist.id = undefined;
                        }
                        artist.first_name = obj.first_name;
                        artist.last_name = obj.last_name;
                        artist.position = obj.position;
                        artists.push(artist);
                    }
                });

                // Create Event Dates ready to be sent to API
                const dates = [...this.state.dates];
                const event_dates = [];
                let hasError = false;

                // Get the Venue timezone and calculate offset minutes between Timezone and UTC
                const venueTimezone = ReturnTimeZone(this.state.event.venue.timezone);
                if (venueTimezone !== '') {
                    const inverseOffset = moment().tz(venueTimezone).format().substring(20,22) * 60;

                    dates.forEach((obj) => {
                        const event_date = {};
                        event_date.id = obj.id;
                        event_date.event_subtitle = obj.event_subtitle;
                        event_date.event_datetime = moment.tz(moment(obj.date).toISOString().substring(0,10) + " " + obj.time, this.state.event.venue.timezone).toISOString();//moment.utc(obj.date.toString().substring(0,15) + " " + obj.time).add(inverseOffset, 'minutes').format();//moment(obj.date.toString().substring(0,15) + " " + obj.time).add(inverseOffset, 'minutes').toDate() || '';
                        let hasPresale = false;
                        if(obj.presale.start_date !== undefined && obj.presale.start_date !== ''){
                            if(obj.presale.start_time === undefined){
                                obj.presale.start_time = '00:00';
                            }
                            hasPresale = true;
                            event_date.presale_start = moment.tz(moment(obj.presale.start_date).toISOString().substring(0,10) + " " + obj.presale.start_time, this.state.event.venue.timezone).toISOString();//moment.utc(obj.presale.start_date.toString().substring(0,15) + " " + obj.presale.start_time).add(inverseOffset, 'minutes').format()//moment(obj.presale.start_date.toString().substring(0,15) + " " + obj.presale.start_time).add(inverseOffset, 'minutes').toDate();
                        } else {
                            event_date.presale_start = undefined;
                        }
                        if(obj.presale.end_date !== undefined && obj.presale.end_date !== ''){
                            if(obj.presale.end_time === undefined){
                                obj.presale.end_time = '00:00';
                            }
                            event_date.presale_end = moment.tz(moment(obj.presale.end_date).toISOString().substring(0,10) + " " + obj.presale.end_time, this.state.event.venue.timezone).toISOString(); //moment.utc(obj.presale.end_date.toString().substring(0,15) + " " + obj.presale.end_time).add(inverseOffset, 'minutes').format()//moment(obj.presale.end_date.toString().substring(0,15) + " " + obj.presale.end_time).add(inverseOffset, 'minutes').toDate();
                        } else {
                            event_date.presale_end = undefined;
                        }

                        // Redeem
                        if (event.details.event_type === 'Video On Demand') {
                            if(obj.redeem.start_date !== undefined && obj.redeem.start_date !== '' && obj.redeem.start_date){
                                if(obj.redeem.start_time === undefined){
                                    obj.redeem.start_time = '00:00';
                                }
                                event_date.redeem_start = moment.tz(moment(obj.redeem.start_date).toISOString().substring(0,10) + " " + obj.redeem.start_time, this.state.event.venue.timezone).toISOString();
                            } else {
                                event_date.predeem_start = undefined;
                            }
                            if(obj.redeem.end_date !== undefined && obj.redeem.end_date !== '' && obj.redeem.end_date){
                                if(obj.redeem.end_time === undefined){
                                    obj.redeem.end_time = '00:00';
                                }
                                event_date.redeem_end = moment.tz(moment(obj.redeem.end_date).toISOString().substring(0,10) + " " + obj.redeem.end_time, this.state.event.venue.timezone).toISOString();
                            } else {
                                event_date.redeem_end = undefined;
                            }
                        }
                        
                        event_date.presale_password = obj.presale.presale_password;
                        if (hasPresale && event_date.presale_password === '') {
                            if (event_date.presale_start.toString() !== event_date.presale_end.toString()) {
                                this.setMessage(window.general_strings.msg.oops, strings.presaleNeedPassword, 'error');
                                hasError = true;
                            }
                        }
                        event_date.sale_start = moment.tz(moment(obj.public.start_date).toISOString().substring(0,10) + " " + obj.public.start_time, this.state.event.venue.timezone).toISOString();
                        //console.log('event_date.sale_start', event_date.sale_start)


                        const dateOriginal = moment.tz(moment(obj.date).toISOString().substring(0,10) + " " + obj.time, this.state.event.venue.timezone).toISOString();

                        //console.log('obj.public.end_date', obj.public.end_date);
                        if(obj.public.end_date !== "" && obj.public.end_date){
                            if (event.details.event_type === 'Video On Demand') {
                                event_date.sale_end = moment.tz(moment(obj.public.end_date).toISOString().substring(0,10) + " " + obj.public.end_time, this.state.event.venue.timezone).subtract(obj.public.end_time, 'hours').toISOString();
                                //console.log('event_date.sale_end', event_date.sale_end);
                            } else {
                                //console.log('parseInt(obj.public.end_time)', parseInt(obj.public.end_time));
                                if(parseInt(obj.public.end_time) <= -1000) {
                                    event_date.sale_end = moment.tz(moment.utc(), this.state.event.venue.timezone).subtract(1, 'days').toDate();
                                    //event_date.sale_end = moment.tz(obj.public.end_date.toString().substring(0,15), this.state.event.venue.timezone).toISOString();
                                } else {
                                    event_date.sale_end = moment.tz(moment(obj.date).toISOString().substring(0,10) + " " + obj.time, this.state.event.venue.timezone).subtract(obj.public.end_time, 'hours').toISOString();
                                }
                            }
                        } else {
                            event_date.sale_end = moment.tz(moment(obj.date).toISOString().substring(0,10) + " " + obj.time, this.state.event.venue.timezone).subtract(obj.public.end_time, 'hours').toISOString() || '';
                        }
                        //console.log('event_date.event_datetime', event_date.event_datetime)
                        //console.log('event_date.sale_end', event_date.sale_end)
                        
                        let section_pricings = [];
                        let previousSectionId = -1;
                        obj.prices.forEach((i) => {
                            let section_pricing = {};
                            if(previousSectionId !== parseInt(i.section)){
                                previousSectionId = parseInt(i.section);
                                section_pricing.id = parseInt(i.section);
                                let options = [];
                                section_pricing.options = options;
                                section_pricings.push(section_pricing);
                            }
                        });
                        obj.prices.forEach((i) => {
                            let option = {};
                            option.id = parseInt(i.price);
                            option.value = i.value;
                            section_pricings.forEach((j) => {
                                if(j.id === parseInt(i.section)){
                                    j.options.push(option);
                                }
                            });
                        });

                        event_date.section_pricing = section_pricings;
                        event_dates.push(event_date);
                    });

                    console.log('event_dates', event_dates);
                }

                let chart = 0;
                if (event.venue.venue_type === 'reserved') {
                    chart = event.venue.chart;
                }

                const acceptRoyalties = this.state.acceptRoyalties;

                const doPost = async () => {
                    try {
                        const createUpdateEventResponse = await createUpdateEvent(event, method, url, acceptRoyalties);
                        console.log('createUpdateEventResponse: ', createUpdateEventResponse);
                        if(createUpdateEventResponse.data.event || createUpdateEventResponse.data.success){
                            this.setMessage(window.general_strings.msg.yay, strings.msg.event_saved, 'success');
                            this.setState({
                                hasNotBeenSavedYet: false,
                            });
                            if(typeof createUpdateEventResponse.data.event !== 'undefined'){
                                this.props.routeProps.history.push('/event/' + createUpdateEventResponse.data.event.id);
                            }
                            this.getActiveEvent(this.props.routeProps.match.params.id, true);
                            this.setState({ isClearUpload:true });
                        } else {
                            let string = '';
                            if(createUpdateEventResponse.data.error.details !== undefined){
                                createUpdateEventResponse.data.error.details.forEach((detail) => {
                                    string += detail.message;
                                    if(detail.field !== ''){
                                        string += ' - ' + detail.field + '<br />';
                                    } else {
                                        string += '<br />';
                                    }
                                });
                            } else {
                                string += createUpdateEventResponse.data.error.code || createUpdateEventResponse.data.error.message;
                            }
                            this.setMessage(window.general_strings.msg.oops, string, 'error'); 
                        }      
                    } catch (error) {
                        this.setMessage(window.general_strings.msg.oops, error, 'error');
                        console.log(error);
                    }
                }

                async function createUpdateEvent(event, method, url, acceptRoyalties) {
                    return await ApiRequest(url, {
                        method: method,
                        data: {
                            event_type: event.details.event_type,
                            name: event.details.name,
                            is_public: is_public,
                            short_name: event.details.short_name,
                            desc: event.details.desc,
                            contact_phone: event.details.contact_phone,
                            contact_email: event.details.contact_email,
                            event_website: event.details.event_website || '',
                            playbilder_url: event.details.playbilder_url || '',
                            mti_show: event.details.mti_show,
                            service_fee: event.details.service_fee,
                            tickets_per_user: parseInt(event.details.tickets_per_user),
                            poster_graphic_id: parseInt(event.details.poster_graphic_id),// || undefined,
                            ad_graphic_id: parseInt(event.details.ad_graphic_id),// || undefined,
                            ad_opt_out: event.details.ad_opt_out,
                            seat_spacing: parseInt(event.details.seat_spacing, 10),
                            //mti_show_id: event.details.mti_show_id,
                            artists: artists,
                            venue: {
                                id: event.venue.id,
                                venue_type: event.venue.venue_type,
                                name: event.venue.name,
                                address: event.venue.address ? event.venue.address : '',
                                country: event.venue.country,
                                city: event.venue.city,
                                state: event.venue.state,
                                zip: event.venue.zip,
                                phone: event.venue.phone ? event.venue.phone : '',
                                fax: event.venue.fax,
                                timezone: event.venue.timezone,
                                seating_chart_id: chart,
                                max_seats: parseInt(event.venue.max_seats) || 0,
                                status: event.venue.status,
                            },
                            pricing_options: pricing_options,
                            fees: fees,
                            event_dates: event_dates,
                            royalties_paid: acceptRoyalties === 'Y' ? true : false,
                            license_access_code: event.details.license_access_code,
                            licensing_house: event.details.licensing_house,
                        }
                    });
                }

                const isStreaming = event.details.event_type === 'Live Stream' || event.details.event_type === 'Scheduled Content' || event.details.event_type === 'Video On Demand';

                // Don't let licence access code empty
                if (isStreaming) {
                    if (event.details.license_access_code === '' && event.details.licensing_house !== 'SR' && event.details.licensing_house !== 'YP' && event.details.licensing_house !== 'MusicRights') {
                        const validation = this.state.validation;
                        validation['details']['license_access_code']['msg'] = 'Please enter a license access code.';
                        validation['details']['license_access_code']['valid'] = false;
                        hasError = true;
                        this.setState({
                            validation,
                        });
                    } else {
                        const validation = this.state.validation;
                        validation['details']['license_access_code']['msg'] = '';
                        validation['details']['license_access_code']['valid'] = true;
                        hasError = false;
                        this.setState({
                            validation,
                        });
                    }
                }

                let validation = this.state.validation;
                // Make sure all Venue required fields are filled
                if (event.venue.name === '' || event.venue.address === '' || event.venue.city === '' || event.venue.zip === '' || event.venue.phone === '') {
                    if (event.venue.name === '') {
                        if (!isStreaming) {
                            validation['venue']['name']['msg'] = 'Venue name is required';
                            validation['venue']['name']['valid'] = false;
                            hasError = true;
                        }
                    }
                    if (event.venue.address === '') {
                        if (!isStreaming) {
                            validation['venue']['address']['msg'] = 'Venue address is required.';
                            validation['venue']['address']['valid'] = false;
                            hasError = true;
                        }
                    }
                    if (event.venue.city === '') {
                        //if (!isStreaming) {
                            validation['venue']['city']['msg'] = 'Venue city is required.';
                            validation['venue']['city']['valid'] = false;
                            hasError = true;
                        //}
                    }
                    if (event.venue.zip === '') {
                        validation['venue']['zip']['msg'] = 'Venue zip is required.';
                        validation['venue']['zip']['valid'] = false;
                        hasError = true;
                    }
                    if (event.venue.phone === '') {
                        if (!isStreaming) {
                            validation['venue']['phone']['msg'] = 'Venue phone is required.';
                            validation['venue']['phone']['valid'] = false;
                            hasError = true;
                        }
                    }
                    
                    this.setState({
                        validation,
                    });
                }

                // Max Seats is required
                if (dates.length === 0 && event.details.event_type !== 'Video On Demand' && props.saveEventMode === 'save') {
                    this.setState({
                        isNoDatesErrorModalOpen: true,
                    });
                    this.setMessage('', '', '');
                } else {
                    if (event.venue.venue_type === 'general-admission' && (event.venue.max_seats === 0 || event.venue.max_seats === '')) {
                        this.setMessage(window.general_strings.msg.oops, 'Quantity of tickets is required.', 'error')
                        validation['venue']['max_seats']['msg'] = 'Quantity of tickets is required.';
                        validation['venue']['max_seats']['valid'] = false;
                        this.setState({
                            validation,
                        });
                    } else {
                        if(!hasError) {
                            if (venueTimezone === '') {
                                this.setMessage(window.general_strings.msg.oops, 'The venue timezone is required.', 'error')
                                validation['venue']['timezone']['msg'] = 'The venue timezone is required.';
                                validation['venue']['timezone']['valid'] = false;
                                this.setState({
                                    validation,
                                });
                            } else {
                                if (event.details.event_type === 'Video On Demand' && isVodEventDateExist) {
                                    doPost();
                                }
                                if (event.details.event_type !== 'Video On Demand') {
                                    doPost();
                                }
                            }
                        } else {
                            this.setMessage('Oops!', 'Make sure all fields are filled properly.', 'error');
                        }
                    }
                }
                
                window.scrollTo(0, 0);
                
            }, 1000);
        }
    }

    setLatLng = (timeZoneId) => {
        const { event } = this.state;
        const { validation } = this.state;
        const options = document.querySelectorAll('.js-timezone-option');
        let hasFoundOption = false;
        options.forEach((option) => {
            if (option.value === timeZoneId) {
                hasFoundOption = true;
                event['venue']['timezone'] = timeZoneId;
            }
        });
        validation.venue.timezone.valid = hasFoundOption;

        this.setState({
            event,
            validation
        }, () => this.validateAllRequiredFields());
    }

    render() { 
        return ( 
            <div>
                <div className="container">
                    <Message 
                        message={this.state.message}
                    />
                </div>
                <Share
                    event={this.state.event} 
                />
                <Details
                    event={this.state.event} 
                    handleChangeType={this.handleChangeType}
                    handleChange={this.handleChange}
                    handleSearch={this.handleSearch}
                    populateEventDetails={this.populateEventDetails}
                    validateRequiredField={this.validateRequiredField}
                    validation={this.state.validation}
                    clearSelectedShow={this.clearSelectedShow}
                    isCloseMTI={this.state.isCloseMTI}
                    handleMTIAccessCode={this.handleMTIAccessCode}
                    handleLicensingHouse={this.handleLicensingHouse}
                    handleDPS={this.handleDPS}
                    isEditMode={this.state.isEditMode}
                />
                <Graphics
                    event={this.state.event} 
                    uploadFile={this.uploadFile}
                    handleSortableInputs={this.handleSortableInputs}
                    clearFile={this.clearFile}
                    onSortEnd={this.onSortEnd}
                    onSortStart={this.onSortStart}
                    deleteRow={this.deleteRow}
                    isClearUpload={this.state.isClearUpload || false}
                    clearImage={this.clearImage}
                />
                <PriceAlertModal 
					isShowModalPriceAlert={this.state.isShowModalPriceAlert}
                    toggleModalPriceAlert={this.toggleModalPriceAlert}
				/>
                <MTIModal 
                    isShowModal={this.state.isMTIModalOpen}
                    event_type={this.state.event.details.event_type}
                    mti_access_result={this.state.mti_access_result}
                    toggleModal={this.toggleModalMTI}
                    acceptRoyalties={this.acceptRoyalties}
				/>
                <NoDatesModalError
                    isShowModal={this.state.isNoDatesErrorModalOpen}
                    toggleModal={this.toggleNoDatesErrorModal}
				/>
                <MTIModalError 
                    isShowModal={this.state.isMTIModalErrorOpen}
                    toggleModal={this.toggleModalMTIError}
				/>
                <DPSModal 
                    client={this.state.client}
                    isShowModal={this.state.isDPSModalOpen}
                    event_type={this.state.event.details.event_type}
                    dps_access_result={this.state.dps_access_result}
                    toggleModal={this.toggleModalDPS}
                    acceptRoyalties={this.acceptRoyaltiesDPS}
				/>
                <ConfirmDeletePrice 
					isConfirmDeletePriceOpen={this.state.isConfirmDeletePriceOpen}
                    toggleConfirmDeletePrice={this.toggleConfirmDeletePrice}
                    confirmDeletePrice={this.confirmDeletePrice} 
				/>
                <ConfirmGlobalChange 
					isConfirmGlobalChangeOpen={this.state.isConfirmGlobalChangeOpen}
                    toggleConfirmGlobalChange={this.toggleConfirmGlobalChange}
				/>
                <Venue
                    user={this.props.user}
                    real_user={this.props.real_user}
                    event={this.state.event} 
                    handleChange={this.handleChange}
                    handleVenueAddressChange={this.handleVenueAddressChange}
                    handleFullVenueAddressChange={this.handleFullVenueAddressChange}
                    setLatLng={this.setLatLng}
                    validateRequiredField={this.validateRequiredField}
                    validation={this.state.validation}
                    loadVenue={this.loadVenue} 
                    clearVenue={this.clearVenue} 
                    uploadFile={this.uploadFile}
                    venues={this.state.venues}
                    venueType={this.state.venueType}
                    selectedMTIshow={this.state.selectedMTIshow}
                />
                {this.state.event.details.event_type !== 'Video On Demand' && this.state.event.details.event_type !== 'Live Stream' && this.state.event.details.event_type !== 'Scheduled Content' && (
                    <Price
                        event={this.state.event} 
                        handleSortableInputs={this.handleSortableInputs} 
                        onSortEnd={this.onSortEnd}
                        onSortStart={this.onSortStart}
                        deleteRow={this.deleteRow}
                        handleChange={this.handleChange}
                    />
                )}
                {this.state.event.details.event_type === 'Video On Demand' && (
                    <PriceVOD
                        event={this.state.event} 
                        handleSortableInputs={this.handleSortableInputs} 
                        onSortEnd={this.onSortEnd}
                        onSortStart={this.onSortStart}
                        deleteRow={this.deleteRow}
                        handleChange={this.handleChange}
                    />
                )}
                {this.state.event.details.event_type === 'Live Stream' && (
                    <PriceStream
                        event={this.state.event} 
                        handleSortableInputs={this.handleSortableInputs} 
                        onSortEnd={this.onSortEnd}
                        onSortStart={this.onSortStart}
                        deleteRow={this.deleteRow}
                        handleChange={this.handleChange}
                    />
                )}
                {this.state.event.details.event_type === 'Scheduled Content' && (
                    <PriceBroadcast
                        event={this.state.event} 
                        handleSortableInputs={this.handleSortableInputs} 
                        onSortEnd={this.onSortEnd}
                        onSortStart={this.onSortStart}
                        deleteRow={this.deleteRow}
                        handleChange={this.handleChange}
                    />
                )}
                <Dates
                    event={this.state.event} 
                    wizard={this.state.wizard} 
                    vod_date={this.state.vod_date} 
                    isWizardError={this.state.isWizardError}
                    handleChange={this.handleChange}
                    handleChangeWizard={this.handleChangeWizard}
                    handleChangeDateWizard={this.handleChangeDateWizard}
                    createEvents={this.createEvents}
                    toggleDatesModal={this.toggleDatesModal}
                    toggleGlobalPriceModal={this.toggleGlobalPriceModal}
                    assignPricingToAll={this.assignPricingToAll}
                    dates={this.state.dates}
                    handleChangeEvent={this.handleChangeEvent}
                    handleChangeDateEvent={this.handleChangeDateEvent}
                    toggleConfirmDeleteEvent={this.toggleConfirmDeleteEvent}
                    isEditMode={this.state.isEditMode}
                    handleChangeVOD={this.handleChangeVOD}
                    handleChangeDateVOD={this.handleChangeDateVOD}
                    createEventVOD={this.createEventVOD}
                    isReadyVOD={this.state.isReadyVOD}
                />
                <DatesModal
                    event={this.state.event} 
                    isDatesModalOpen={this.state.isDatesModalOpen}
                    toggleDatesModal={this.toggleDatesModal}
                    savePricing={this.savePricing}
                    prices={this.state.prices}
                />
                <GlobalPriceModal
                    event={this.state.event} 
                    isGlobalPriceModalOpen={this.state.isGlobalPriceModalOpen}
                    toggleGlobalPriceModal={this.toggleGlobalPriceModal}
                    saveGlobalPricing={this.saveGlobalPricing}
                    prices={this.state.prices}
                />
                <ConfirmDeleteEventModal
                    toggleConfirmDeleteEvent={this.toggleConfirmDeleteEvent}
                    isConfirmDeleteEventOpen={this.state.isConfirmDeleteEventOpen} 
                    confirmConfirmDeleteEvent={this.confirmConfirmDeleteEvent}
                    modalTitle={this.state.modalTitle}
                    modalDescription={this.state.modalDescription}
                    modalButton={this.state.modalButton}
				/>
                <Prompt
                    when={this.state.hasNotBeenSavedYet}
                    message={strings.promptQuit}
                />
            </div>    
        )
    }
}

CreateEvent.propTypes = {
    routeProps: PropTypes.shape({
        match: PropTypes.shape({
            params: PropTypes.object
        }).isRequired
    }).isRequired,
    saveEventMode: PropTypes.string
}
 
export default CreateEvent;



// WEBPACK FOOTER //
// ./src/components/CreateEvent/CreateEvent.js